import { InverterDataContent } from '@/api/interfaces/content/form/serviceDriven/inverterDataContent';
import { ConnectionRulesType } from '@/types/forms/shared/connectionRulesType';

export const invertersContent: InverterDataContent[] = [
    {
        zerezId: '__MOCK_FRONTEND',
        manufacturerName: '__MOCK_FRONTEND',
        moduleType: '__MOCK_FRONTEND',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [
            ConnectionRulesType.rules4105,
            ConnectionRulesType.rules4110,
        ],
    },
    {
        zerezId: 'ZE-MJSX-7VRY-0001',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: 'MAX.STORAGE.Ultimate 6',
        activePower: 6.0,
        apparentPower: 6.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-7VRY-0002',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: 'MAX.STORAGE.Ultimate 8',
        activePower: 8.0,
        apparentPower: 8.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-7VRY-0003',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: 'MAX.STORAGE.Ultimate 10',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-7VRY-0004',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: 'MAX.STORAGE.Ultimate 12',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-7VRY-0005',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: 'MAX.STORAGE.Ultimate 15',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-OP70-0001',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '17SHT',
        activePower: 17.0,
        apparentPower: 18.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-OP70-0002',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '20SHT',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-OP70-0003',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '22SHT',
        activePower: 22.0,
        apparentPower: 24.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-OP70-0004',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '25SHT',
        activePower: 25.0,
        apparentPower: 27.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-OP70-0005',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '28SHT',
        activePower: 28.0,
        apparentPower: 30.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-OP70-0006',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '30SHT',
        activePower: 30.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-EF8J-0001',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '6SMT',
        activePower: 6.0,
        apparentPower: 6.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-EF8J-0002',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '8SMT',
        activePower: 8.0,
        apparentPower: 8.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-EF8J-0003',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '10SMT',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-EF8J-0004',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '13SMT',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-EF8J-0005',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '15SMT',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-AG2K-0001',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '1000SP',
        activePower: 1.0,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-AG2K-0002',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '2000SP',
        activePower: 2.0,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-AG2K-0003',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '2500SP',
        activePower: 2.5,
        apparentPower: 2.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-AG2K-0004',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '3000SP',
        activePower: 3.0,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MJSX-AG2K-0005',
        manufacturerName: 'SOLARMAX GmbH',
        moduleType: '4600SP',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-F3A2-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M88H_121',
        activePower: 66.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-F3A2-0002',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M88H_122',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-GTF9-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'RPI M10A',
        activePower: 10.0,
        apparentPower: 10.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-GTF9-0002',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'RPI M8A',
        activePower: 8.0,
        apparentPower: 8.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-GTF9-0003',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'RPI M6A',
        activePower: 6.0,
        apparentPower: 6.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-U8I7-G2QK-0009',
        manufacturerName: 'Hanwha Q CELLS GmbH',
        moduleType: 'Q.VOLT H30.0 T-FP',
        activePower: 30.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-0G9S-33YM-0001',
        manufacturerName: 'CSI Solar Co., Ltd.',
        moduleType: 'CSI-60K-T4001A-E',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-0G9S-33YM-0002',
        manufacturerName: 'CSI Solar Co., Ltd.',
        moduleType: 'CSI-50K-T4001A-E',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-0G9S-33YM-0003',
        manufacturerName: 'CSI Solar Co., Ltd.',
        moduleType: 'CSI-40K-T4001A-E',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-0G9S-QRR8-0001',
        manufacturerName: 'CSI Solar Co., Ltd.',
        moduleType: 'CSI-25K-T4001A-E',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-0G9S-QRR8-0002',
        manufacturerName: 'CSI Solar Co., Ltd.',
        moduleType: 'CSI-23K-T4001A-E',
        activePower: 23.0,
        apparentPower: 23.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-0G9S-QRR8-0003',
        manufacturerName: 'CSI Solar Co., Ltd.',
        moduleType: 'CSI-20K-T4001A-E',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-0G9S-QRR8-0004',
        manufacturerName: 'CSI Solar Co., Ltd.',
        moduleType: 'CSI-17K-T4001A-E',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-0G9S-QRR8-0005',
        manufacturerName: 'CSI Solar Co., Ltd.',
        moduleType: 'CSI-15K-T4001A-E',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-C4SY-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'PCS100HV',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0001',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE25K',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0002',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE50K',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0003',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE27.6K',
        activePower: 27.6,
        apparentPower: 27.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0004',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE55K',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0005',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE82.8K',
        activePower: 82.8,
        apparentPower: 82.8,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0006',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE30K**',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0007',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE30K',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0008',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE90K',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0009',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE30K*',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0010',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE90K*',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0011',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE33.3K',
        activePower: 33.3,
        apparentPower: 33.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0012',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE66.6K',
        activePower: 66.6,
        apparentPower: 66.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0013',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE100K',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0014',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE33.3K*',
        activePower: 33.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0015',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE66.6K*',
        activePower: 66.6,
        apparentPower: 66.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0016',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE100K*',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0017',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE40K',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0018',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE80K',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NZT3-G33B-0019',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE120K',
        activePower: 120.0,
        apparentPower: 120.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-K3N5-58XY-0001',
        manufacturerName: 'VOLTRONIC POWER TECHNOLOGY (SHENZHEN) CORP.',
        moduleType: 'INFINISOLAR 15KW',
        activePower: 14.9,
        apparentPower: 14.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-K3N5-X3RU-0001',
        manufacturerName: 'VOLTRONIC POWER TECHNOLOGY (SHENZHEN) CORP.',
        moduleType: 'INFINISOLAR PLUS 5KW',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-R3J1-L2VU-0001',
        manufacturerName: 'Ulectric Technology Co., Ltd.',
        moduleType: 'CPH4K',
        activePower: 4.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-R3J1-L2VU-0002',
        manufacturerName: 'Ulectric Technology Co., Ltd.',
        moduleType: 'CPH5K',
        activePower: 5.0,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-R3J1-L2VU-0003',
        manufacturerName: 'Ulectric Technology Co., Ltd.',
        moduleType: 'CPH6K',
        activePower: 6.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-R3J1-L2VU-0004',
        manufacturerName: 'Ulectric Technology Co., Ltd.',
        moduleType: 'CPH8K',
        activePower: 8.0,
        apparentPower: 8.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-R3J1-L2VU-0005',
        manufacturerName: 'Ulectric Technology Co., Ltd.',
        moduleType: 'CPH10K',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-R3J1-L2VU-0006',
        manufacturerName: 'Ulectric Technology Co., Ltd.',
        moduleType: 'CPH12K',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-YFS3-T5BR-0001',
        manufacturerName: 'Qingdao Nahui Energy Technology Co., Ltd',
        moduleType: 'N3PH-1N5K',
        activePower: 5.0,
        apparentPower: 5.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-YFS3-T5BR-0002',
        manufacturerName: 'Qingdao Nahui Energy Technology Co., Ltd',
        moduleType: 'N3PH-1N6K',
        activePower: 6.0,
        apparentPower: 6.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-YFS3-T5BR-0003',
        manufacturerName: 'Qingdao Nahui Energy Technology Co., Ltd',
        moduleType: 'N3PH-1N8K',
        activePower: 8.0,
        apparentPower: 8.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-YFS3-T5BR-0004',
        manufacturerName: 'Qingdao Nahui Energy Technology Co., Ltd',
        moduleType: 'N3PH-1N10K',
        activePower: 10.0,
        apparentPower: 10.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-P719-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 25000TL-30',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-P719-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 2000TL-30',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-P719-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 15000TL-30',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7CMF-CCJL-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M70A_260',
        activePower: 70.0,
        apparentPower: 77.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-CCJL-0002',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M70A_262',
        activePower: 70.0,
        apparentPower: 77.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-CCJL-0003',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M50A_260',
        activePower: 50.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-W50T-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 255KTL-HV',
        activePower: 255.0,
        apparentPower: 255.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-W50T-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 250KTL-HV',
        activePower: 250.0,
        apparentPower: 250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-K3N5-MTCQ-0001',
        manufacturerName: 'VOLTRONIC POWER TECHNOLOGY (SHENZHEN) CORP.',
        moduleType: 'InfiniSolar 10k-PAR-B, InfiniSolar 10k',
        activePower: 9.9,
        apparentPower: 9.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-RY3O-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: ' M100A_280',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7CMF-RY3O-0002',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M100A_280',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0019',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-Pro-30.0',
        activePower: 30.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0020',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-Pro-30.0',
        activePower: 30.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-I3JJ-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-5K-MAP0',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-I3JJ-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-6K-MAP0',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-I3JJ-0003',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-8K-MAP0',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-I3JJ-0004',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN5000-8K-MAP0',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-I3JJ-0005',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-10K-MAP0',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-I3JJ-0006',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-12K-MAP0',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-I3JJ-0007',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN5000-12K-MAP0',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-7UPU-0001',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'BAT 600-24',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-7UPU-0002',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'BAT 600-48',
        activePower: 0.5,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-7UPU-0003',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'BAT 1200-24',
        activePower: 1.0,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-7UPU-0004',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'BAT 1200-48',
        activePower: 1.1,
        apparentPower: 1.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-7UPU-0005',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'BAT 2000-48',
        activePower: 1.7,
        apparentPower: 1.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-7UPU-0006',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'BAT 2800-48',
        activePower: 2.4,
        apparentPower: 2.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-7UPU-0007',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'BAT 2000-96',
        activePower: 1.8,
        apparentPower: 1.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-7UPU-0008',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'BAT 3200-96',
        activePower: 2.8,
        apparentPower: 3.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-7UPU-0009',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'BAT 2400-48',
        activePower: 2.1,
        apparentPower: 2.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0001',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 600-17',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0002',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 700-35',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0003',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 900-60',
        activePower: 0.7,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0004',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 1200-60',
        activePower: 1.0,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0005',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 1200-90',
        activePower: 1.0,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0006',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 1300-35',
        activePower: 1.0,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0007',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 1500-90',
        activePower: 1.3,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0008',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 1600-60',
        activePower: 1.4,
        apparentPower: 1.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0009',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 1800-35',
        activePower: 1.5,
        apparentPower: 1.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0010',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 2000-60',
        activePower: 1.7,
        apparentPower: 1.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0011',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 2000-90',
        activePower: 1.7,
        apparentPower: 1.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0012',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 2400-90',
        activePower: 1.9,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0013',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 2600-60',
        activePower: 2.2,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-5ELH-FHBI-0014',
        manufacturerName: 'SolarInvert GmbH',
        moduleType: 'SOL 3000-90',
        activePower: 2.6,
        apparentPower: 2.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NICT-PR3T-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-60KTL-HV-D1-001',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-NICT-PR3T-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-55KTL-HV-D1',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-NICT-PR3T-0003',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-55KTL-IN-HV-D1',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-NICT-PR3T-0004',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-55KTL-HV-D1-001',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-NZT3-CJ7D-0001',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE50K',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-CJ7D-0002',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE55K',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-CJ7D-0003',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE66.6K',
        activePower: 66.6,
        apparentPower: 66.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-CJ7D-0004',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE82.8K',
        activePower: 82.8,
        apparentPower: 82.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-CJ7D-0005',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE90K',
        activePower: 89.9,
        apparentPower: 89.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-CJ7D-0006',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE90K*',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-CJ7D-0007',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE100K',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-QLZZ-2XMZ-0001',
        manufacturerName: 'SAX Power GmbH',
        moduleType: 'HOME-1-6-5-230',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-QLZZ-2XMZ-0002',
        manufacturerName: 'SAX Power GmbH',
        moduleType: 'HOME-2-6-4-230',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-QLZZ-2XMZ-0003',
        manufacturerName: 'SAX Power GmbH',
        moduleType: 'HOME plus-1-8-5-230',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-QLZZ-2XMZ-0004',
        manufacturerName: 'SAX Power GmbH',
        moduleType: 'HOME plus-2-8-4-230',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-JYGC-CR6A-0001',
        manufacturerName: 'Alpha ESS Co., Ltd.',
        moduleType: 'SMILE-S6-HV-INV',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0001',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-4kW-25A-1',
        activePower: 4.0,
        apparentPower: 4.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0002',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-5kW-25A-1',
        activePower: 5.0,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0003',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-6kW-25A-1',
        activePower: 6.0,
        apparentPower: 6.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0004',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-8kW-25A-1',
        activePower: 8.0,
        apparentPower: 8.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0005',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-10kW-25A-1',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0006',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-12kW-25A-1',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0007',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-10kW-40A-1',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0008',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-12kW-40A-1',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0009',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-15kW-40A-1',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6LB1-89C4-0010',
        manufacturerName: 'DreamMaker Technologie GmbH',
        moduleType: 'PCS-3-20kW-40A-1',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6VV5-AUV7-0001',
        manufacturerName: 'Sunset Energietechnik GmbH',
        moduleType: 'SUN3Grid 12000/3 Hybrid',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-F4N4-DOMS-0001',
        manufacturerName: 'ads-tec Energy GmbH',
        moduleType: 'DVK-CPT1XXX YYY-ZZ/RR mit Leistungsstufe 87 kVA',
        activePower: 86.6,
        apparentPower: 86.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-F4N4-DOMS-0002',
        manufacturerName: 'ads-tec Energy GmbH',
        moduleType: 'DVK-CPT1XXX YYY-ZZ/RR mit Leistungsstufe 69 kVA',
        activePower: 69.3,
        apparentPower: 69.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-F4N4-DOMS-0003',
        manufacturerName: 'ads-tec Energy GmbH',
        moduleType: 'DVK-CPT1XXX YYY-ZZ/RR mit Leistungsstufe 55 kVA',
        activePower: 55.4,
        apparentPower: 55.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-F4N4-DOMS-0004',
        manufacturerName: 'ads-tec Energy GmbH',
        moduleType: 'DVK-CPT1XXX YYY-ZZ/RR mit Leistungsstufe 44 kVA',
        activePower: 43.6,
        apparentPower: 43.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-F4N4-DOMS-0005',
        manufacturerName: 'ads-tec Energy GmbH',
        moduleType: 'DVK-CPT1XXX YYY-ZZ/RR mit Leistungsstufe 22 kVA',
        activePower: 22.2,
        apparentPower: 22.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0001',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS4780-PV-4-440-5',
        activePower: 4780.0,
        apparentPower: 4780.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0002',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3260-PV-2-600-5',
        activePower: 3260.0,
        apparentPower: 3260.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0003',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6520-PV-4-600-5',
        activePower: 6520.0,
        apparentPower: 6520.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0004',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3430-PV-2-630-5',
        activePower: 3430.0,
        apparentPower: 3430.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0005',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6860-PV-4-630-5',
        activePower: 6860.0,
        apparentPower: 6860.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0006',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3590-PV-2-660-5',
        activePower: 3590.0,
        apparentPower: 3590.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0007',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS7180-PV-4-660-5',
        activePower: 7180.0,
        apparentPower: 7180.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0008',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3750-PV-2-690-5',
        activePower: 3750.0,
        apparentPower: 3750.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0009',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS7500-PV-4-690-5',
        activePower: 7500.0,
        apparentPower: 7500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0010',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS4780-ES-4-440-5',
        activePower: 4780.0,
        apparentPower: 4780.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0011',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3130-ES-2-575-5',
        activePower: 3130.0,
        apparentPower: 3130.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0012',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6260-ES-4-575-5',
        activePower: 6260.0,
        apparentPower: 6260.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0013',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3260-ES-2-600-5',
        activePower: 3260.0,
        apparentPower: 3260.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0014',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6520-ES-4-600-5',
        activePower: 6520.0,
        apparentPower: 6520.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0015',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3430-ES-2-630-5',
        activePower: 3430.0,
        apparentPower: 3430.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0016',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6860-ES-4-630-5',
        activePower: 6860.0,
        apparentPower: 6860.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0017',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3590-ES-2-660-5',
        activePower: 3590.0,
        apparentPower: 3590.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0018',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS7180-ES-4-660-5',
        activePower: 7180.0,
        apparentPower: 7180.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0019',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3750-ES-2-690-5',
        activePower: 3750.0,
        apparentPower: 3750.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-ATD6-0020',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS7500-ES-4-690-5',
        activePower: 7500.0,
        apparentPower: 7500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-ME6T-VSRE-0001',
        manufacturerName: 'SENEC GmbH',
        moduleType: 'SENEC.Home P4 5 - Hybrid',
        activePower: 11.8,
        apparentPower: 11.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ME6T-VSRE-0002',
        manufacturerName: 'SENEC GmbH',
        moduleType: 'SENEC.Home P4 4 - Hybrid',
        activePower: 11.8,
        apparentPower: 11.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ME6T-VSRE-0003',
        manufacturerName: 'SENEC GmbH',
        moduleType: 'SENEC.Home P4 3 - Hybrid',
        activePower: 11.8,
        apparentPower: 11.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ME6T-VSRE-0004',
        manufacturerName: 'SENEC GmbH',
        moduleType: 'SENEC.Home P4 2 - Hybrid',
        activePower: 11.8,
        apparentPower: 11.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ME6T-VSRE-0005',
        manufacturerName: 'SENEC GmbH',
        moduleType: 'SENEC.Home P4 5 - AC',
        activePower: 11.8,
        apparentPower: 11.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ME6T-VSRE-0006',
        manufacturerName: 'SENEC GmbH',
        moduleType: 'SENEC.Home P4 4 - AC',
        activePower: 11.8,
        apparentPower: 11.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-IG8Z-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'F3000',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-IG8Z-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'F3600',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-IG8Z-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'F4600',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-OGX2-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO 10',
        activePower: 10.0,
        apparentPower: 10.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-OGX2-0002',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO 12',
        activePower: 12.0,
        apparentPower: 12.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-OGX2-0003',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO 15',
        activePower: 15.0,
        apparentPower: 15.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-OGX2-0004',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO 17',
        activePower: 17.0,
        apparentPower: 17.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-OGX2-0005',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO 20',
        activePower: 20.0,
        apparentPower: 20.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-FJYF-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO CI 100',
        activePower: 100.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-03XE-5B9I-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO CI 50',
        activePower: 50.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-03XE-5B9I-0002',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO CI 60',
        activePower: 60.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-23KTL-M3',
        activePower: 23.0,
        apparentPower: 23.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-RY6M-CEO4-0001',
        manufacturerName: 'Aiswei B.V.',
        moduleType: 'ASW1000-S-G2',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RY6M-CEO4-0002',
        manufacturerName: 'Aiswei B.V.',
        moduleType: 'ASW1500-S-G2',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RY6M-CEO4-0003',
        manufacturerName: 'Aiswei B.V.',
        moduleType: 'ASW2000-S-G2',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RY6M-CEO4-0004',
        manufacturerName: 'Aiswei B.V.',
        moduleType: 'ASW2500-S-G2',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RY6M-CEO4-0005',
        manufacturerName: 'Aiswei B.V.',
        moduleType: 'ASW3000-S-G2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RY6M-CEO4-0006',
        manufacturerName: 'Aiswei B.V.',
        moduleType: 'ASW3680-S-G2',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RY6M-CEO4-0007',
        manufacturerName: 'Aiswei B.V.',
        moduleType: 'ASW4000-S-G2',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RY6M-CEO4-0008',
        manufacturerName: 'Aiswei B.V.',
        moduleType: 'ASW5000-S-G2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-RY6M-CEO4-0009',
        manufacturerName: 'Aiswei B.V.',
        moduleType: 'ASW6000-S-G2',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-Pro-10.0',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-Pro-12.0',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-Pro-15.0',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0004',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-Pro-20.0',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0005',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-Pro-22.0',
        activePower: 22.0,
        apparentPower: 24.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0006',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-Pro-24.9',
        activePower: 24.9,
        apparentPower: 24.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0007',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-Pro-25.0',
        activePower: 25.0,
        apparentPower: 27.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0008',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-Pro-29.9',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0009',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-Pro-10.0',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0010',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-Pro-12.0',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0011',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-Pro-15.0',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0012',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-Pro-20.0',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0013',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-Pro-22.0',
        activePower: 22.0,
        apparentPower: 24.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0014',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-Pro-24.9',
        activePower: 24.9,
        apparentPower: 24.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0015',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-Pro-25.0',
        activePower: 25.0,
        apparentPower: 27.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V8CY-0016',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-Pro-29.9',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-25K-MB0',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-20K-MB0',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0003',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-17K-MB0',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0004',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-15K-MB0',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0005',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-12K-MB0',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0006',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-25KTL-M5',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0007',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-20KTL-M5',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0008',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-17KTL-M5',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0009',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-15KTL-M5',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0010',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-12KTL-M5',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0011',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN5000-25K-MB0',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-2TGU-0012',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN5000-17K-MB0',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1VE3-MWL4-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'LUNA2000-200KTL-H0',
        activePower: 200.0,
        apparentPower: 200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1VE3-MWL4-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'LUNA2000-200KTL-H1',
        activePower: 200.0,
        apparentPower: 200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NICT-NOWE-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-100KTL-M2',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-NICT-NOWE-0003',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-115KTL-M2',
        activePower: 115.0,
        apparentPower: 115.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-QVZR-IL0A-0001',
        manufacturerName: 'neoom international gmbh',
        moduleType: 'TERRA',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NICT-EETJ-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'LUNA2000-100KTL-M1',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-QVZR-X7Q8-0001',
        manufacturerName: 'neoom international gmbh',
        moduleType: 'BLOKK/BLOKK Light',
        activePower: 88.0,
        apparentPower: 88.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-Z0W1-0SFO-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-60KTL-HV-D1-001',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Z0W1-0SFO-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-55KTL-HV-D1',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Z0W1-0SFO-0004',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-55KTL-IN-HV-D1',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Z0W1-0SFO-0005',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-55KTL-HV-D1-001',
        activePower: 55.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7CMF-62FF-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M100A_280',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7CMF-FPM7-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M30A_230',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-FPM7-0002',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M30A_231',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-FPM7-0003',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M20A_220',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-FPM7-0004',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'M15A_220',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-361L-0001',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-22KW-3P-A-0-E3',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-361L-0002',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-22KW-3P-A-3-E3',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-361L-0003',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-22KW-3P-A-4-E3',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-361L-0004',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-22KW-3P-A-5-E3',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-361L-0005',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-22KW-3P-A-6-E3',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-361L-0006',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-22KW-3P-A-7-E3',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-VAN0-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'ZPM-PCS125K-R',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-OLVY-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-125K-5G-PRO',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7CMF-3EK7-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'RPI-M20A',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-3EK7-0002',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'RPI-M15A',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-0JEZ-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-330KTL-H1',
        activePower: 300.0,
        apparentPower: 300.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-0JEZ-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-330KTL-H2',
        activePower: 275.0,
        apparentPower: 275.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-C7QL-OSFZ-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P0.6K-M',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C7QL-OSFZ-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P0.7K-M',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C7QL-OSFZ-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P1K-M',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C7QL-OSFZ-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P1.5K-M',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C7QL-OSFZ-0005',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P2K-M',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C7QL-OSFZ-0006',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P2.5K-M',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C7QL-OSFZ-0007',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P3K-M',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C7QL-OSFZ-0008',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P3.6K-M',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0007',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M35G4-EU-Q0',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0008',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M45G4-EU-Q0',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0009',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M35G4-EU-Q0-P',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0010',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M45G4-EU-Q0-P',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-D37V-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-3.6K-SG03LP1-EU',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-D37V-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-5K-SG03LP1-EU',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-D37V-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-6K-SG03LP1-EU',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-1K-G04P1-EU-AM1',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-1.5K-G04P1-EU-AM1',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-2K-G04P1-EU-AM1',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-2.2K-G04P1-EU-AM1',
        activePower: 2.2,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-2.5K-G04P1-EU-AM1',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-2.7K-G04P1-EU-AM1',
        activePower: 2.7,
        apparentPower: 2.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0007',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-3K-G04P1-EU-AM1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0008',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-3.3K-G04P1-EU-AM1',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0009',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-3.6K-G04P1-EU-AM1',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-9P71-0010',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-4K-G04P1-EU-AM1',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'AI-W5.1-3.6P1-EU-B',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'AI-W5.1-5P1-EU-B',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'AI-W5.1-6P1-EU-B',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'AI-W5.1-4.6P1-EU-B',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'AI-W5.1-7P1-EU-B',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'AI-W5.1-7.6P1-EU-B',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0007',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'AI-W5.1-8P1-EU-B',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0008',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-3.6K-SG05LP1-EU',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0009',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-4.6K-SG05LP1-EU',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0010',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-5K-SG05LP1-EU',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0011',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-6K-SG05LP1-EU',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0012',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-7.6K-SG05LP1-EU',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0013',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-8K-SG05LP1-EU',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0014',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-3.6K-SG05LP1-EU-AM2-P',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0015',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-5K-SG05LP1-EU-AM2-P',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0016',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-6K-SG05LP1-EU-AM2-P',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0017',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-7.6K-SG05LP1-EU-AM2-P',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-PJ9S-0018',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-8K-SG05LP1-EU-AM2-P',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-DXHC-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M60G4-EU-Q0',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-DXHC-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M80G4-EU-Q0',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-DXHC-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M100G4-EU-Q0',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-DXHC-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M60G4-EU-Q0-P',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-DXHC-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M80G4-EU-Q0-P',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-DXHC-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M100G4-EU-Q0-P',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M130G4-EU-Q0',
        activePower: 1.3,
        apparentPower: 1.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M160G4-EU-Q0',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M180G4-EU-Q0',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M200G4-EU-Q0',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M220G4-EU-Q0',
        activePower: 2.2,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M130G4-EU-Q0-I',
        activePower: 1.3,
        apparentPower: 1.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0007',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M160G4-EU-Q0-I',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0008',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M180G4-EU-Q0-I',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0009',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M200G4-EU-Q0-I',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-OKEC-0010',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M220G4-EU-Q0-I',
        activePower: 2.2,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N6HE-N6V6-0001',
        manufacturerName: 'Qingdao NaHui Intelligent Technologies Co.,Ltd',
        moduleType: 'HM1P-600',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N6HE-N6V6-0002',
        manufacturerName: 'Qingdao NaHui Intelligent Technologies Co.,Ltd',
        moduleType: 'HM1P-800',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-E00V-KTN7-0001',
        manufacturerName: 'FSP Power Solution GmbH',
        moduleType: 'Power Manager 15kW',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-E00V-MUTE-0001',
        manufacturerName: 'FSP Power Solution GmbH',
        moduleType: 'Power Manager 10kW',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-8BPD-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'PCS2000-108K-MB1',
        activePower: 108.0,
        apparentPower: 108.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-RR3E-0002',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 4013',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-RR3E-0003',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 5013',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-RR3E-0004',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 6013',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-5.0-D-E',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-5.0-D-C',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-5.0-N-E',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-5.0-N-C',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-6.0-D-E',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-6.0-D-C',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-6.0-N-E',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0008',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-6.0-N-C',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0009',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-8.0-D-E',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0010',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-8.0-D-C',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0011',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-8.0-N-E',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0012',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-8.0-N-C',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0013',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-10.0-D-E',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0014',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-10.0-D-C',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0015',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-10.0-N-E',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0016',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-10.0-N-C',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0017',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-8.0E',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0018',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-8.0C',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0019',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-10.0E',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-KCUS-0020',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-10.0C',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-D6KZ-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'LUNA2000-213KTL-H0',
        activePower: 213.0,
        apparentPower: 213.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-SRAB-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-150K-MG0',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-SRAB-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN5000-150K-MG0',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-A3EK-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'PCS2000-108KTL-MB1',
        activePower: 108.0,
        apparentPower: 108.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-OQZD-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'LUNA2000-100KTL-M1',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-9KJB-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-150K-MG0',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-9KJB-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN5000-150K-MG0',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ID2G-CSJH-0001',
        manufacturerName: 'Stabl Energy GmbH',
        moduleType: 'SI100',
        activePower: 67.5,
        apparentPower: 67.5,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-427P-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-100KTL-M2',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-427P-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-115KTL-M2',
        activePower: 115.0,
        apparentPower: 115.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-M51H-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-100KTL-M1',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-M861-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-50KTL-M3',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-UUMH-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-30KTL-M3',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-UUMH-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-36KTL-M3',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-UUMH-0003',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-40KTL-M3',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-X2UV-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-4.6KTL-L1',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-X2UV-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-4KTL-L1',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-X2UV-0003',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-3.68KTL-L1',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-X2UV-0004',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-3KTL-L1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-X2UV-0005',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-2KTL-L1',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-10KTL-M1',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-8KTL-M1',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0003',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-6KTL-M1',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0004',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-5KTL-M1',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0005',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-4KTL-M1',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0006',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-3KTL-M1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0007',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-10KTL-M0',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0008',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-8KTL-M0',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0009',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-6KTL-M0',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0010',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-5KTL-M0',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0011',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-4KTL-M0',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-LJEA-0012',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-3KTL-M0',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-20KTL-M2',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-17KTL-M2',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0003',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-15KTL-M2',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0004',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-12KTL-M2',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0005',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-10KTL-M2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0006',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-8KTL-M2',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0007',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-20KTL-M0',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0008',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-17KTL-M0',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0009',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-15KTL-M0',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0010',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-12KTL-M0',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0011',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-10KTL-M0',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-4T1T-0012',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-8KTL-M0',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-HDBB-POA9-0007',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-90KTL-H0',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-POA9-0008',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-90KTL-H1',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-POA9-0009',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-90KTL-H2',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-POA9-0010',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-95KTL-INH0',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-POA9-0011',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-95KTL-INH1',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-POA9-0012',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-100KTL-H1',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-POA9-0013',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-105KTL-H1',
        activePower: 105.0,
        apparentPower: 105.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-OB26-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 70KTL-V3',
        activePower: 70.0,
        apparentPower: 77.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-OB26-0004',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 75KTL-V3',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-OB26-0005',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 80KTL-V3',
        activePower: 80.0,
        apparentPower: 88.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-OB26-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 60KTL-V3 D2',
        activePower: 60.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-OB26-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 60KTL-V3',
        activePower: 60.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-120Z-W89L-0001',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MAX 100KTL3-X LV',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-W89L-0002',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MAX 110KTL3-X LV',
        activePower: 110.0,
        apparentPower: 122.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-W89L-0003',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MAX 120KTL3-X LV',
        activePower: 120.0,
        apparentPower: 133.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-W89L-0004',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MAX 125KTL3-X',
        activePower: 125.0,
        apparentPower: 139.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-W5TZ-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SBS2.5-1VL-10',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-L4CJ-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SBS3.7-10',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-L4CJ-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SBS5.0-10',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-L4CJ-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SBS6.0-10',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-2Z2M-0001',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'NEO 1600M-X2',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-2Z2M-0002',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'NEO 1800M-X2',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-2Z2M-0003',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'NEO 2000M-X2',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-2Z2M-0004',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'NEO 2250M-X2',
        activePower: 2.2,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-2Z2M-0005',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'NEO 2500M-X2',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-SX6V-0001',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 3000TL BL-UP',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-SX6V-0002',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 3600TL BL-UP',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-SX6V-0003',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 4000TL BL-UP',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-SX6V-0004',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 4600TL BL-UP',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-SX6V-0005',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'Growatt SPH3000',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-SX6V-0006',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'Growatt SPH 3600',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-SX6V-0007',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'Growatt SPH 4000',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-SX6V-0008',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'Growatt SPH 4600',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-37KG-0001',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MID 11KTL3-XH',
        activePower: 11.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-37KG-0002',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MID 12KTL3-XH',
        activePower: 12.2,
        apparentPower: 13.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-37KG-0003',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MID 13KTL3-XH',
        activePower: 13.3,
        apparentPower: 14.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-37KG-0004',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MID 15KTL3-XH',
        activePower: 15.3,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-37KG-0005',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MID 17KTL3-XH',
        activePower: 17.4,
        apparentPower: 193.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-37KG-0006',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MID 20KTL3-XH',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-37KG-0007',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MID 25KTL3-XH',
        activePower: 25.6,
        apparentPower: 28.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-37KG-0008',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'MID 30KTL3-XH',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-SRAF-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 5KTL-3PH',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-SRAF-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 6KTL-3PH',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-SRAF-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 8KTL-3PH',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-SRAF-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 10KTL-3PH',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-SRAF-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 15KTL-3PH',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-SRAF-0006',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 20KTL-3PH',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-K810-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 15KTLX-G3',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-K810-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 17KTLX-G3',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-K810-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 20KTLX-G3',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-K810-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 22KTLX-G3',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-K810-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 24KTLX-G3',
        activePower: 24.0,
        apparentPower: 24.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-253F-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 3000-EP',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-253F-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 3680-EP',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-253F-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 4000-EP',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-253F-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 4600-EP',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-DEII-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SB1.5-1VL-40',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-DEII-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SB2.0-1VL-40',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-DEII-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SB2.5-1VL-40',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-8VSH-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 15000TL-30',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-8VSH-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 17000TL-30',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-8VSH-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 20000TL-30',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-8VSH-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 25000TL-30',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-O3PU-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 12-50',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-O3PU-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 15-50',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-O3PU-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 20-50',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-O3PU-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 25-50',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KYRG-M3TZ-0001',
        manufacturerName: 'Jiangsu Skyworth New Energy Technology Co.,Ltd',
        moduleType: 'SWH005KH-T1',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KYRG-M3TZ-0002',
        manufacturerName: 'Jiangsu Skyworth New Energy Technology Co.,Ltd',
        moduleType: 'SWH008KH-T1',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KYRG-M3TZ-0003',
        manufacturerName: 'Jiangsu Skyworth New Energy Technology Co.,Ltd',
        moduleType: 'SWH010KH-T1',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KYRG-M3TZ-0004',
        manufacturerName: 'Jiangsu Skyworth New Energy Technology Co.,Ltd',
        moduleType: 'SWH012KH-T1',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KYRG-M3TZ-0005',
        manufacturerName: 'Jiangsu Skyworth New Energy Technology Co.,Ltd',
        moduleType: 'SWH015KH-T1',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-UAUD-0001',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 4000TL3 BH-UP',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-UAUD-0002',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 5000TL3 BH-UP',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-UAUD-0003',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 6000TL3 BH-UP',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-UAUD-0004',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 7000TL3 BH-UP',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-UAUD-0005',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 8000TL3 BH-UP',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-UAUD-0006',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'SPH 10000TL3 BH-UP',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0012',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-5K-A',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0013',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-10K-A',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0014',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-15K-A',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0009',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-10K-P',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0010',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-12K-P',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0011',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-15K-P',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0008',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-8K-P',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-J5Y1-0001',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'NEO 600M-X',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-J5Y1-0002',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'NEO 800M-X',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-120Z-J5Y1-0003',
        manufacturerName: 'Growatt New Energy GmbH',
        moduleType: 'NEO 1000M-X',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ID2G-1ZNL-0001',
        manufacturerName: 'Stabl Energy GmbH',
        moduleType: 'SI100',
        activePower: 67.5,
        apparentPower: 67.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0010',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-15KTL-M3',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0011',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-17KTL-M3',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0012',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-20KTL-M3',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0013',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-28KTL-M3',
        activePower: 27.5,
        apparentPower: 27.5,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0014',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-30KTL-M3',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0015',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-36KTL-M3',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0016',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-40KTL-M3',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0017',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-42KTL-M3',
        activePower: 42.0,
        apparentPower: 42.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-I3J7-0018',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-50KTL-M3',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-JXUR-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 30KTL-V3',
        activePower: 30.0,
        apparentPower: 34.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-JXUR-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 33KTL-V3',
        activePower: 33.0,
        apparentPower: 37.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-JXUR-0004',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 36KTL-V3',
        activePower: 36.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-JXUR-0005',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 40KTL-V3',
        activePower: 40.0,
        apparentPower: 44.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-JXUR-0006',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 45KTL-V3',
        activePower: 45.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-JXUR-0007',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 50KTL-V3',
        activePower: 50.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-UIHQ-ICDK-0001',
        manufacturerName: 'Poweroak GmbH',
        moduleType: 'EP600',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-JXUR-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 25KTL-V3',
        activePower: 25.0,
        apparentPower: 28.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-0WGP-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 75KTL',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-0WGP-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 80KTL',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-0WGP-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 100KTL',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-0WGP-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 110KTL',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-0WGP-0006',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 100KTL-HV',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-0WGP-0007',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 125KTL-HV',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-0WGP-0008',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 136KTL-HV',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-6RMY-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3000SP',
        activePower: 3.0,
        apparentPower: 3.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-FJKV-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH HYD5000 ZSS',
        activePower: 5.0,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-FJKV-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH HYD6000 ZSS',
        activePower: 6.0,
        apparentPower: 6.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-FJKV-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH HYD8000 ZSS',
        activePower: 8.0,
        apparentPower: 8.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-FJKV-0004',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH HYD10000 ZSS',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-FJKV-0005',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH HYD15000 ZSS',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-FJKV-0006',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH HYD20000 ZSS',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-N8PL-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH HYD3000 ZP1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-N8PL-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH HYD3680 ZP1',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-N8PL-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH HYD4000 ZP1',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-N8PL-0004',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH HYD4600 ZP1',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-0HMY-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH HYD3000 ZSS HP',
        activePower: 3.0,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-0HMY-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH HYD3600 ZSS HP',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-0HMY-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH HYD4000 ZSS HP',
        activePower: 4.0,
        apparentPower: 4.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-0HMY-0004',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH HYD4600 ZSS HP',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-6K3O-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW0.8K-MIS-G10',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-2NQ5-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 3000TLM-V3',
        activePower: 3.0,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-2NQ5-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 3680TLM-V3',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-2NQ5-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 4000TLM-V3',
        activePower: 4.0,
        apparentPower: 4.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-2NQ5-0004',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 4600TLM-V3',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-7DYA-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 1600TL-V3',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-7DYA-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 2200TL-V3',
        activePower: 2.2,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-7DYA-0004',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 2700TL-V3',
        activePower: 2.7,
        apparentPower: 2.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-7DYA-0005',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 3000TL-V3',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-7DYA-0006',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 3300TL-V3',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-7DYA-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 1PH 1100TL-V3',
        activePower: 1.1,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-T2ML-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW136K-HTH',
        activePower: 136.0,
        apparentPower: 136.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-T2ML-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW120K-HT',
        activePower: 120.0,
        apparentPower: 120.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-T2ML-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW110K-HT',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-T2ML-0007',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K-HT',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-XSFU-E2ZS-0001',
        manufacturerName: 'Renac Power Technology Co., Ltd.',
        moduleType: 'R3-50K',
        activePower: 50.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XSFU-E2ZS-0002',
        manufacturerName: 'Renac Power Technology Co., Ltd.',
        moduleType: 'R3-40K',
        activePower: 40.0,
        apparentPower: 44.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XSFU-E2ZS-0003',
        manufacturerName: 'Renac Power Technology Co., Ltd.',
        moduleType: 'R3-36K',
        activePower: 36.0,
        apparentPower: 39.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XSFU-E2ZS-0004',
        manufacturerName: 'Renac Power Technology Co., Ltd.',
        moduleType: 'R3-30K',
        activePower: 30.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-MJMO-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P30K-H',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-MJMO-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P40K-H',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-MJMO-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P50K-H',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-MJMO-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P29.9K-H',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-UQ4Y-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 60KTLX-G3',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-UQ4Y-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 60KTLX2-G3',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-UQ4Y-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 70KTLX-G3',
        activePower: 70.0,
        apparentPower: 70.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-UQ4Y-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 75KTLX-G3',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-UQ4Y-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 80KTLX-G3',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-I9G1-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Boost-6K-G4',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-AQ4M-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 4600-EP',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-AQ4M-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 4000-EP',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-AQ4M-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 3680-EP',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-AQ4M-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 3000-EP',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-DJC3-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'ESI 3K-S1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-DJC3-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'ESI 3.68K-S1',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-DJC3-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'ESI 4K-S1',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-DJC3-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'ESI 4.6K-S1',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 25KTLX-G3',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 30KTLX-G3',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 30KTLX-G3-A',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 33KTLX-G3',
        activePower: 33.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 36KTLX-G3',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0006',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 40KTLX-G3',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0007',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 45KTLX-G3',
        activePower: 45.0,
        apparentPower: 45.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0008',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 50KTLX-G3',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0009',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 40KTLX-G3-HV',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-A783-0010',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 50KTLX-G3-HV',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-TI1U-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 3KTLM-G3',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-TI1U-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 3.6KTLM-G3',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-TI1U-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 4KTLM-G3',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-TI1U-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 4.6KTLM-G3',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-0LB2-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 1100TL-G3',
        activePower: 1.1,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-0LB2-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 1600TL-G3',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-0LB2-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 2200TL-G3',
        activePower: 2.2,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-0LB2-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 2700TL-G3',
        activePower: 2.7,
        apparentPower: 2.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-0LB2-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 3000TL-G3',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-0LB2-0006',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 3300TL-G3',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-D2HX-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'MR1600',
        activePower: 1.6,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-D2HX-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'MR2000',
        activePower: 2.0,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-D2HX-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'MR2400',
        activePower: 2.4,
        apparentPower: 2.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-IEA8-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'MR600',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-IEA8-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'MR800',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-IEA8-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'MR1000',
        activePower: 1.0,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0001',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 50KTL',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0002',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 50KTL-Q3/EU',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0003',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 50KTL-Q3/EU-CSB',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0004',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 50KTL-S3/EU',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0005',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 50KTL-D3/EU',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0006',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 60KTL',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0007',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 60KTL-Q3/EU',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0008',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 60KTL-Q3/EU-CSB',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0009',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 60KTL-S3/EU',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-0IYH-0010',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 60KTL-D3/EU',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-D8Q4-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 110KTL-V4',
        activePower: 110.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-D8Q4-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 125KTL-V4-A',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-D8Q4-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 100KTL-V4',
        activePower: 100.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-TR9Z-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 60KTL-V3 D2',
        activePower: 60.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-TR9Z-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 70KTL-V3',
        activePower: 70.0,
        apparentPower: 77.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-TR9Z-0004',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 75KTL-V3',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-TR9Z-0005',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 80KTL-V3',
        activePower: 80.0,
        apparentPower: 88.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-KV5O-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-100KTL-M1',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-KV5O-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-100KTL-INM0',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-TR9Z-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 60KTL-V3',
        activePower: 60.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-VUA3-0005',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 350KTL-HV Z0',
        activePower: 352.0,
        apparentPower: 352.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-VUA3-0006',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: ' AZZURRO 3PH 250KTL-HV Z0',
        activePower: 250.0,
        apparentPower: 250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-VUA3-0007',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: ' AZZURRO 3PH 330KTL-HV Z0',
        activePower: 330.0,
        apparentPower: 330.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-VUA3-0008',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: ' AZZURRO 3PH 330KTL-HV Z1',
        activePower: 330.0,
        apparentPower: 330.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-VUA3-0009',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: ' AZZURRO 3PH 350KTL-HV Z1',
        activePower: 352.0,
        apparentPower: 352.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0010',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K07-ETC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0011',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K07-ETC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0012',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K06-ETC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0013',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K05-ETC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0014',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K06-ETC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0015',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K05-ETC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0016',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K07-BTC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0017',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K06-BTC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0018',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K05-BTC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0019',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K07-BTC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0020',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K06-BTC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-O2V3-0021',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K05-BTC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-GRI2-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW250K-HT',
        activePower: 250.0,
        apparentPower: 250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-GRI2-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW225K-HT',
        activePower: 225.0,
        apparentPower: 225.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-GRI2-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW250KN-HT',
        activePower: 250.0,
        apparentPower: 250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-GRI2-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW225KN-HT',
        activePower: 225.0,
        apparentPower: 225.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-840X-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW350KH-UT',
        activePower: 352.0,
        apparentPower: 352.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-840X-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW320KH-UT',
        activePower: 320.0,
        apparentPower: 320.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-840X-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW350K-UT',
        activePower: 352.0,
        apparentPower: 352.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-840X-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW320K-UT',
        activePower: 320.0,
        apparentPower: 320.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-PWRY-N2QV-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'ZPM-PCS215K-R',
        activePower: 215.0,
        apparentPower: 215.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-PWRY-N2QV-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'ZPM-PCS125K-R',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-9H9G-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 5KTL-3PH',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-9H9G-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 6KTL-3PH',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-9H9G-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 8KTL-3PH',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-9H9G-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 10KTL-3PH',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-9H9G-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 15KTL-3PH',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-9H9G-0006',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 20KTL-3PH',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-VCN7-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 80KTLX-G3',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-VCN7-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 75KTLX-G3',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-VCN7-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 70KTLX-G3',
        activePower: 70.0,
        apparentPower: 70.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-VCN7-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 60KTLX-G3',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-VCN7-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 60KTLX2-G3',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-QVZR-9BON-0001',
        manufacturerName: 'neoom international gmbh',
        moduleType: 'NEEO HYD 10KTL',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-QVZR-9BON-0002',
        manufacturerName: 'neoom international gmbh',
        moduleType: 'NEEO HYD 15KTL',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-QVZR-9BON-0003',
        manufacturerName: 'neoom international gmbh',
        moduleType: 'NEEO HYD 20KTL',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-VJDL-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 5KTL-3PH',
        activePower: 5.0,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-VJDL-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 6KTL-3PH',
        activePower: 6.0,
        apparentPower: 6.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-VJDL-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 8KTL-3PH',
        activePower: 8.0,
        apparentPower: 8.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-VJDL-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 10KTL-3PH',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-VJDL-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 10KTL-3PH-A',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-VJDL-0006',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 15KTL-3PH',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-VJDL-0007',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'HYD 20KTL-3PH',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-RFUW-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 50KTLX-G3',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-RFUW-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 20KTLX-G3',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-RFUW-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 25KTLX-G3',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-RFUW-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 30KTLX-G3',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-RFUW-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 33KTLX-G3',
        activePower: 33.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-RFUW-0006',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 36KTLX-G3',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-RFUW-0007',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 40KTLX-G3',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-RFUW-0008',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 45KTLX-G3',
        activePower: 45.0,
        apparentPower: 45.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-S3FZ-1UA1-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 125KTLX-G4-A',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-1UA1-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 125KTLX-G4',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-1UA1-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 110KTLX-G4',
        activePower: 100.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-1UA1-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 100KTLX-G4',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-WFYZ-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 350KTLX0',
        activePower: 352.0,
        apparentPower: 352.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-WFYZ-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 250KTLX0',
        activePower: 250.0,
        apparentPower: 250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-WFYZ-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 330KTLX0',
        activePower: 330.0,
        apparentPower: 330.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-WFYZ-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 330KTLX1',
        activePower: 330.0,
        apparentPower: 330.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-WFYZ-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 350KTLX1',
        activePower: 352.0,
        apparentPower: 352.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-2PEF-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 125KTLX-G4-A',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-2PEF-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 125KTLX-G4',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-2PEF-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 110KTLX-G4',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-2PEF-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 100KTLX-G4',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KAXY-HMNH-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-BK60SG01-EU-AM2',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-HMNH-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-BK80SG01-EU-AM2',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-HMNH-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-BK100SG01-EU-AM2',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-D1AO-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-70K-G03',
        activePower: 70.0,
        apparentPower: 70.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-D1AO-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-75K-G03',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-D1AO-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-80K-G03',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-D1AO-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-90K-G03',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-D1AO-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-100K-G03',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-D1AO-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-110K-G03',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-C4RP-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-29.9K-SG01HP3-EU-BM3',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-C4RP-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-30K-SG01HP3-EU-BM3',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-C4RP-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-35K-SG01HP3-EU-BM3',
        activePower: 35.0,
        apparentPower: 35.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-C4RP-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-40K-SG01HP3-EU-BM4',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-C4RP-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-50K-SG01HP3-EU-BM4',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P3K-H-EU',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P4K-H-EU',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P5K-H-EU',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P6K-H-EU',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0005',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P8K-H-EU',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0006',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P10K-H-EU',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0007',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P3K-H-EU-OD',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0008',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P4K-H-EU-OD',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0009',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P5K-H-EU-OD',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0010',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P6K-H-EU-OD',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0011',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P8K-H-EU-OD',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0012',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P10K-H-EU-OD',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0013',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P8K-H-EU-PRO',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0014',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P10K-H-EU-PRO',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0015',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P5K2-H',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0016',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P6K2-H',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0017',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P8K2-H',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0018',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P10K2-H',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0019',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P5K2-H-OD',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0020',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P6K2-H-OD',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0021',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P8K2-H-OD',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0022',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EH3P10K2-H-OD',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0023',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EA3P5KAA-NV-ND-H',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0024',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EA3P6KAA-NV-ND-H',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0025',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EA3P8KAA-NV-ND-H',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-5325-0026',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EA3P10KAA-NV-ND-H',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-YLSY-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-18K-G04',
        activePower: 18.0,
        apparentPower: 18.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-YLSY-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-20K-G04',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-YLSY-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-25K-G04',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-YLSY-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-30K-G04',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-YLSY-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-33K-G04',
        activePower: 33.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-YLSY-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-35K-G04',
        activePower: 35.0,
        apparentPower: 35.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-YLSY-0007',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-36K-G04',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 12KTLX-G3',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 11KTLX-G3-A',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 10KTLX-G3-A',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 11KTLX-G3',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 8.8KTLX-G3-A',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0006',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 8.8KTLX-G3',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0007',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 6.6KTLX-G3',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0008',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 5.5KTLX-G3',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0009',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 5.5KTLX-G3-A',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0010',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 4.4KTLX-G3',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-S3FZ-JPK9-0011',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 3.3KTLX-G3',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-M0UT-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-14K-SG05LP3-EU-SM2',
        activePower: 14.0,
        apparentPower: 14.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-M0UT-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-15K-SG05LP3-EU-SM2',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-M0UT-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-16K-SG05LP3-EU-SM2',
        activePower: 16.0,
        apparentPower: 16.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-M0UT-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-18K-SG05LP3-EU-SM2',
        activePower: 18.0,
        apparentPower: 18.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-M0UT-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-20K-SG05LP3-EU-SM2',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-FC2I-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'RHI-3P5K-HVES-5G',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-FC2I-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'RHI-3P6K-HVES-5G',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-FC2I-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'RHI-3P8K-HVES-5G',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-FC2I-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'RHI-3P10K-HVES-5G',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-5K-SG01HP3-EU-AM2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-6K-SG01HP3-EU-AM2',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-8K-SG01HP3-EU-AM2',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-10K-SG01HP3-EU-AM2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-12K-SG01HP3-EU-AM2',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-15K-SG01HP3-EU-AM2',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0007',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-20K-SG01HP3-EU-AM2',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0008',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-25K-SG01HP3-EU-AM2',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0009',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'GB-S5K-EU-B',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0010',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'GB-S6K-EU-B',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0011',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'GB-S8K-EU-B',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0012',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'GB-S10K-EU-B',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0013',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'GB-S12K-EU-B',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0014',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'GB-S15K-EU-B',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0015',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'GB-S20K-EU-B',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-WF99-0016',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'GB-S25K-EU-B',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HNMI-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EA1P3K-L',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HNMI-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EA1P3.6K-L',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HNMI-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-EA1P4.6K-L',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-50K-LV-5G',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-60K-LV-5G',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-80K-5G',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-100K-5G',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0005',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-110K-5G',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0006',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC50K-LV',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0007',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC60K-LV',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0008',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC75K',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0009',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC80K',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0010',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC100K',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-L7VW-0011',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC110K',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-58LI-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-5K-SG01HP3-EU-DM2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-58LI-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-6K-SG01HP3-EU-DM2',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-58LI-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-8K-SG01HP3-EU-DM2',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-58LI-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-10K-SG01HP3-EU-DM2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-58LI-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-12K-SG01HP3-EU-DM2',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-VLJG-0001',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'A5143',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-3K-G06P3-EU-AM2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-4K-G06P3-EU-AM2',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-5K-G06P3-EU-AM2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-6K-G06P3-EU-AM2',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-7K-G06P3-EU-AM2',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-8K-G06P3-EU-AM2',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0007',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-9K-G06P3-EU-AM2',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0008',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-10K-G06P3-EU-AM2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0009',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-12K-G06P3-EU-AM2',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0010',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-15K-G06P3-EU-AM2',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0011',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-3K-G06P3-EU-AM2-P1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0012',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-4K-G06P3-EU-AM2-P1',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0013',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-5K-G06P3-EU-AM2-P1',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0014',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-6K-G06P3-EU-AM2-P1',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0015',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-7K-G06P3-EU-AM2-P1',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0016',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-8K-G06P3-EU-AM2-P1',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0017',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-9K-G06P3-EU-AM2-P1',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0018',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-10K-G06P3-EU-AM2-P1',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0019',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-12K-G06P3-EU-AM2-P1',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0020',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-15K-G06P3-EU-AM2-P1',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0021',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-3K-G06P3-EU-BM2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0022',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-4K-G06P3-EU-BM2',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0023',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-5K-G06P3-EU-BM2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0024',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-6K-G06P3-EU-BM2',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0025',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-7K-G06P3-EU-BM2',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0026',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-8K-G06P3-EU-BM2',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0027',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-9K-G06P3-EU-BM2',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0028',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-10K-G06P3-EU-BM2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0029',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-12K-G06P3-EU-BM2',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0030',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-15K-G06P3-EU-BM2',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0031',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-3K-G06P3-EU-BM2-P1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0032',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-4K-G06P3-EU-BM2-P1',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0033',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: '  SUN-5K-G06P3-EU-BM2-P1',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0034',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: '  SUN-6K-G06P3-EU-BM2-P1',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0035',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: '  SUN-7K-G06P3-EU-BM2-P1',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0036',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: '  SUN-8K-G06P3-EU-BM2-P1',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0037',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: '  SUN-9K-G06P3-EU-BM2-P1',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0038',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: '  SUN-12K-G06P3-EU-BM2-P1',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0039',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: '  SUN-15K-G06P3-EU-BM2-P1',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-G3SR-0040',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: '  SUN-10K-G06P3-EU-BM2-P1',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-5ZNH-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-4K-SG05LP3-EU-SM2',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-5ZNH-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-5K-SG05LP3-EU-SM2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-5ZNH-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-6K-SG05LP3-EU-SM2',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-5ZNH-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-8K-SG05LP3-EU-SM2',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-5ZNH-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-10K-SG05LP3-EU-SM2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-5ZNH-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: ' SUN-12K-SG05LP3-EU-SM2',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-6SFZ-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-3.6K-G05P1-EU-AM2',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-6SFZ-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-4K-G05P1-EU-AM2',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-6SFZ-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-4.2K-G05P1-EU-AM2',
        activePower: 4.2,
        apparentPower: 4.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-6SFZ-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-4.6K-G05P1-EU-AM2',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0001',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M30G4-EU-Q0-P',
        activePower: 0.3,
        apparentPower: 0.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0002',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M40G4-EU-Q0-P',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0003',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M50G4-EU-Q0-P',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0004',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M30G4-EU-Q0',
        activePower: 0.3,
        apparentPower: 0.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0005',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M40G4-EU-Q0',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KAXY-Q7JR-0006',
        manufacturerName: 'Ningbo Deye Inverter Technology Co., Ltd.',
        moduleType: 'SUN-M50G4-EU-Q0',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-WUQY-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC50K',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-WUQY-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC60K',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-WUQY-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC25K-LV',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-WUQY-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC30K-LV',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-WUQY-0005',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC36K-LV',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XSFU-DBX4-0002',
        manufacturerName: 'Renac Power Technology Co., Ltd.',
        moduleType: 'N3-HV-8.0',
        activePower: 8.0,
        apparentPower: 8.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XSFU-DBX4-0003',
        manufacturerName: 'Renac Power Technology Co., Ltd.',
        moduleType: 'N3-HV-6.0',
        activePower: 6.0,
        apparentPower: 6.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XSFU-DBX4-0004',
        manufacturerName: 'Renac Power Technology Co., Ltd.',
        moduleType: 'N3-HV-5.0',
        activePower: 5.0,
        apparentPower: 5.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XSFU-DBX4-0001',
        manufacturerName: 'Renac Power Technology Co., Ltd.',
        moduleType: 'N3-HV-10.0',
        activePower: 10.0,
        apparentPower: 10.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-25K-5G',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-30K-5G',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-33K-5G',
        activePower: 33.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-36K-5G',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0005',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-40K-5G',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0006',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-15K-LV-5G',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0007',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-20K-LV-5G',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0008',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-23K-LV-5G',
        activePower: 23.0,
        apparentPower: 23.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0009',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC25K',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0010',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC30K',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0011',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC33K',
        activePower: 33.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0012',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC36K',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0013',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC40K',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0014',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC15K-LV',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0015',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC20K-LV',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-HKZ4-0016',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC23K-LV',
        activePower: 23.0,
        apparentPower: 23.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-GBF1-EPB2-0006',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG25CX-P2',
        activePower: 25.0,
        apparentPower: 27.5,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GBF1-EPB2-0007',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG30CX-P2',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GBF1-EPB2-0008',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG33CX-P2',
        activePower: 33.0,
        apparentPower: 36.3,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GBF1-EPB2-0009',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG36CX-P2',
        activePower: 36.0,
        apparentPower: 39.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GBF1-EPB2-0010',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG40CX-P2',
        activePower: 40.0,
        apparentPower: 44.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GBF1-EPB2-0011',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG50CX-P2',
        activePower: 50.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-BAP5-0001',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG1100UD',
        activePower: 1100.0,
        apparentPower: 1265.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-BAP5-0002',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG1100UD-20',
        activePower: 1100.0,
        apparentPower: 1265.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GBF1-BPYZ-0002',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG285HX',
        activePower: 285.0,
        apparentPower: 285.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-GBF1-BPYZ-0003',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG350HX',
        activePower: 320.0,
        apparentPower: 352.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-ONYQ-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SHP75-10',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-ONYQ-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP60-10',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-ONYQ-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STPS60-10',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-HDBB-Q1L9-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SHP75-10',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-Q1L9-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STPS60-10',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-Q1L9-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP60-10',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P4K',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P5K',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P5K-LV',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0005',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P6K',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0006',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P6K-LV',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0007',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P8K',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0008',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P9K',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0009',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P10K',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0010',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P10K-LV',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0011',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P12K',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0012',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P13K',
        activePower: 13.0,
        apparentPower: 13.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0013',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P15K',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0014',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P17K',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0015',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P20K',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-VAN9-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 110-60',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-VNLU-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GR3P3K',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-I6U7-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P0.6K-UM',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-I6U7-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GR1P0.8K-UM',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-1ST5-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GC60K-LV',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-1ST5-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GC75K-LV',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-1ST5-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GC80K',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-1ST5-0005',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GC100K',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-1ST5-0006',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GC110K',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-1ST5-0007',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GC125K',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-SY4I-0001',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 100KTL-M3',
        activePower: 100.0,
        apparentPower: 111.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-8PPZ-SY4I-0002',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 110KTL-M3',
        activePower: 110.0,
        apparentPower: 123.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-9CKH-0009',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 25KTL-D3',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-9CKH-0010',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 25KTL-D3/EU',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-9CKH-0011',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 25KTL-D3/EU-CSB',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-9CKH-0012',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 28KTL-D3',
        activePower: 28.0,
        apparentPower: 28.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-9CKH-0013',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 28KTL-D3/EU',
        activePower: 28.0,
        apparentPower: 28.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-9CKH-0014',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 28KTL-D3/EU-CSB',
        activePower: 28.0,
        apparentPower: 28.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-9CKH-0015',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 30KTL-D3',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-9CKH-0016',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 30KTL-D3/EU',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-9CKH-0017',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 30KTL-D3/EU-CSB',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-U8I7-G2QK-0001',
        manufacturerName: 'Hanwha Q CELLS GmbH',
        moduleType: 'Q.VOLT H10.0 T-FP',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-U8I7-G2QK-0002',
        manufacturerName: 'Hanwha Q CELLS GmbH',
        moduleType: 'Q.VOLT H12.0 T-FP',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-U8I7-G2QK-0003',
        manufacturerName: 'Hanwha Q CELLS GmbH',
        moduleType: 'Q.VOLT H15.0 T-FP',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-U8I7-G2QK-0004',
        manufacturerName: 'Hanwha Q CELLS GmbH',
        moduleType: 'Q.VOLT H20.0 T-FP',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-U8I7-G2QK-0005',
        manufacturerName: 'Hanwha Q CELLS GmbH',
        moduleType: 'Q.VOLT H22.0 T-FP',
        activePower: 22.0,
        apparentPower: 24.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-U8I7-G2QK-0006',
        manufacturerName: 'Hanwha Q CELLS GmbH',
        moduleType: 'Q.VOLT H24.9 T-FP',
        activePower: 24.9,
        apparentPower: 24.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-U8I7-G2QK-0007',
        manufacturerName: 'Hanwha Q CELLS GmbH',
        moduleType: 'Q.VOLT H25.0 T-FP',
        activePower: 25.0,
        apparentPower: 27.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-U8I7-G2QK-0008',
        manufacturerName: 'Hanwha Q CELLS GmbH',
        moduleType: 'Q.VOLT H29.9 T-FP',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-40VT-L06U-0002',
        manufacturerName: 'sonnen GmbH',
        moduleType: 'sonnenPro FlexStack/92',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-40VT-L06U-0003',
        manufacturerName: 'sonnen GmbH',
        moduleType: 'sonnenPro FlexStack/184',
        activePower: 184.0,
        apparentPower: 184.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-40VT-L06U-0004',
        manufacturerName: 'sonnen GmbH',
        moduleType: 'sonnenPro FlexStack/276',
        activePower: 276.0,
        apparentPower: 276.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-40VT-L06U-0005',
        manufacturerName: 'sonnen GmbH',
        moduleType: 'sonnenPro FlexStack/368',
        activePower: 368.0,
        apparentPower: 368.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-CTP9-0001',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 75KTL',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-CTP9-0002',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 80KTL',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-CTP9-0003',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 100KTL',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-CTP9-0004',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 110KTL',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-CTP9-0005',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 100KTL-HV',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-CTP9-0006',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 125KTL-HV',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-CTP9-0007',
        manufacturerName: 'Shenzhen SOFARSOLAR Co., Ltd.',
        moduleType: 'SOFAR 136KTL-HV',
        activePower: 136.0,
        apparentPower: 136.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DFN7-1ST5-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S6-GC50K-LV',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AKKJ-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW700-XS-11',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AKKJ-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW1000-XS-11',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AKKJ-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW1500-XS-11',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AKKJ-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW2000-XS-11',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AKKJ-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW2500-XS-11',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AKKJ-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3000-XS-11',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-IHNO-0001',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMT-2000-4T',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-IHNO-0002',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMT-1800-4T',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-IHNO-0003',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMT-1600-4T',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-0D5Z-0001',
        manufacturerName: 'EcoFlow Inc.',
        moduleType: 'EF HD-P3-12K-S1',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-0D5Z-0002',
        manufacturerName: 'EcoFlow Inc.',
        moduleType: 'EF HD-P3-6K0-S1',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-0D5Z-0003',
        manufacturerName: 'EcoFlow Inc.',
        moduleType: 'EF HD-P3-8K0-S1',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-0D5Z-0004',
        manufacturerName: 'EcoFlow Inc.',
        moduleType: 'EF HD-P3-10K-S1',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-NW23-0001',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'MS-A2-FX',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AQ2J-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW700-XS-30',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AQ2J-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW1000-XS-30',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AQ2J-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW1500-XS-30',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AQ2J-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW2000-XS-30',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AQ2J-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW2500-XS-30',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AQ2J-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3000-XS-30',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AQ2J-0007',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3300-XS-30',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-58NW-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3000-DNS-30',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-58NW-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600-DNS-30',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-58NW-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW4200-DNS-30',
        activePower: 4.2,
        apparentPower: 4.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-58NW-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000-DNS-30',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-58NW-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000-DNS-30',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-9U6H-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K-GT',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-9U6H-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW110K-GT',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-9U6H-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW125K-GT',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-DBEB-0001',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-1200',
        activePower: 1.2,
        apparentPower: 1.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-DBEB-0002',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-1600',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-DBEB-0003',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-1800',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-0.6-S-D(L)',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-0.6-S-N(L)',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-0.7-S-D(L)',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-0.7-S-N(L)',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-0.8-S-D(L)',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-0.8-S-N(L)',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-1.1-S-D(L)',
        activePower: 1.1,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0008',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-1.1-S-N(L)',
        activePower: 1.1,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0009',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-1.5-S-D(L)',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0010',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-1.5-S-N(L)',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0011',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-2.0-S-D(L)',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0012',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-2.0-S-N(L)',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0013',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-2.5K-S-D(L)',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0014',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-2.5K-S-N(L)',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0015',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-3K-S-D(L)',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0016',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-3K-S-N(L)',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0017',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-3.3K-S-D(L)',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0018',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-3.3K-S-N(L)',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0019',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-3.6K-S-D(L)',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-A1YI-0020',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-3.6K-S-N(L)',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5H6A-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW15K-ET',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5H6A-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW20K-ET',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5H6A-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW25K-ET',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5H6A-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW29.9K-ET',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5H6A-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW30K-ET',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-6KZ9-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-168KTL-H1',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-6KZ9-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-185KTL-H1',
        activePower: 175.0,
        apparentPower: 175.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-6KZ9-0003',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-215KTL-H0',
        activePower: 200.0,
        apparentPower: 200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-6KZ9-0004',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-215KTL-H3',
        activePower: 200.0,
        apparentPower: 200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Z0W1-2UOU-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-33KTL-A',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-Z0W1-2UOU-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-36KTL',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-ELZD-88AM-0001',
        manufacturerName: 'VARTA Storage GmbH',
        moduleType: 'Element backup (Ausbaustufe 6.5kWh, M-UF.271-00F)',
        activePower: 1.9,
        apparentPower: 1.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ELZD-88AM-0002',
        manufacturerName: 'VARTA Storage GmbH',
        moduleType: 'Element backup (Ausbaustufe 13.0kWh, M-UF.271-00F)',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ELZD-88AM-0003',
        manufacturerName: 'VARTA Storage GmbH',
        moduleType: 'Element backup (Ausbaustufe 19.5kWh, M-UF.271-00F)',
        activePower: 4.0,
        apparentPower: 4.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-80K',
        activePower: 80.0,
        apparentPower: 88.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-100K',
        activePower: 100.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-110K',
        activePower: 110.0,
        apparentPower: 121.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-120K',
        activePower: 120.0,
        apparentPower: 132.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-125K',
        activePower: 125.0,
        apparentPower: 132.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-136K',
        activePower: 136.0,
        apparentPower: 149.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-150K',
        activePower: 150.0,
        apparentPower: 165.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0008',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-80K(L)',
        activePower: 80.0,
        apparentPower: 88.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0009',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-100K(L)',
        activePower: 100.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0010',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-110K(L)',
        activePower: 110.0,
        apparentPower: 121.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0011',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-120K(L)',
        activePower: 120.0,
        apparentPower: 132.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0012',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-125K(L)',
        activePower: 125.0,
        apparentPower: 132.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0013',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-136K(L)',
        activePower: 136.0,
        apparentPower: 149.6,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-11VK-0014',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-150K(L)',
        activePower: 150.0,
        apparentPower: 165.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-ZQ5I-A91Q-0001',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-600',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-A91Q-0002',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-800',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-A91Q-0003',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-1000',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-Y6DH-0001',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-600N',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-Y6DH-0002',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-800N',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-Y6DH-0003',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-1000N',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-Y6DH-0004',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-600NW',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-Y6DH-0005',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-800NW',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-Y6DH-0006',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'HERF-1000NW',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-LU5A-0001',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-600',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-LU5A-0002',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-800',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-LU5A-0003',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-1000',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-LU5A-0004',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-600-W',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-LU5A-0005',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-800-W',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-LU5A-0006',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-1000-W',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-2N73-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW75K-SMT',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-2N73-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW80K-SMT',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-3.0-E-G2-WL',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-3.7-E-G2-WL',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-4.6-E-G2-WL',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0004',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-5.0-E-G2-WL',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0005',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-6.0-E-G2-WL',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0006',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-4.6-E1-G2-WL',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0007',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-5.0-E1-G2-WL',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0008',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-6.0-E1-G2-WL',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0009',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-3.0-E-G2-WL',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0010',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-3.7-E-G2-WL',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0011',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-4.6-E-G2-WL',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0012',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-5.0-E-G2-WL',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0013',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-6.0-E-G2-WL',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0014',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-4.6-E1-G2-WL',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0015',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-5.0-E1-G2-WL',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0016',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-6.0-E1-G2-WL',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0017',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-3.0-E-G2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0018',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-3.7-E-G2',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0019',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-4.6-E-G2',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0020',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-5.0-E-G2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0021',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-6.0-E-G2',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0022',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-4.6-E1-G2',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0023',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H1-5.0-E1-G2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0024',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-3.0-E-G2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0025',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-3.7-E-G2',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0026',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-4.6-E-G2',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0027',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-5.0-E-G2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0028',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-6.0-E-G2',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0029',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-4.6-E1-G2',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-SZJD-0030',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC1-5.0-E1-G2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-IQJY-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: '1K5-HI-5-V1',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-IQJY-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: '1K5-HI-6-V1',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-IQJY-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: '1K5-HI-8-V1',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-IQJY-0004',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: '1K5-HI-10-V1',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-IQJY-0005',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: '1K5-HI-12-V1',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-IQJY-0006',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: '1K5-HI-15-V1',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AQPM-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K-ET-10',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-AQPM-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW40K-ET-10',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-SYVT-0001',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid SolBrid 10-3-2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-SYVT-0002',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid SolBrid 10-3-4',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9T7M-0001',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 4213',
        activePower: 4.2,
        apparentPower: 4.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9T7M-0002',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 5513',
        activePower: 5.5,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9T7M-0003',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 7013',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9T7M-0004',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 8513',
        activePower: 8.5,
        apparentPower: 8.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9T7M-0005',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 10013',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9BZZ-0001',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 1511',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9BZZ-0002',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 2011',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9BZZ-0003',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'SecaGrid 2511',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9BZZ-0004',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 3011_2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9BZZ-0005',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 3011',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9BZZ-0006',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 3611',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9BZZ-0007',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 3611_2',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9BZZ-0008',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 4611_2',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-9BZZ-0009',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 5011_2',
        activePower: 4.6,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-VR4Z-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50KS-MT',
        activePower: 50.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-VR4Z-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW60KS-MT',
        activePower: 60.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-5.0-Smart',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-6.0-Smart',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-8.0-Smart',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0004',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-9.9-Smart',
        activePower: 9.9,
        apparentPower: 9.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0005',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-10.0-Smart',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0006',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-12.0-Smart',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0007',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-15.0-Smart',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0008',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-5.0-Smart',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0009',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-6.0-Smart',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0010',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-8.0-Smart',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0011',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-9.9-Smart',
        activePower: 9.9,
        apparentPower: 9.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0012',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-10.0-Smart',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0013',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-12.0-Smart',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-22O7-0014',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-15.0-Smart',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V2SR-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'F3000-G2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V2SR-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'F3600-G2',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-V2SR-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'F4600-G2',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-V96D-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SI4.4M-13',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-V96D-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SI6.0H-13',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-V96D-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SI8.0H-13',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-9DV1-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 50-40',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-9DV1-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 50-41',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1CTK-XLWF-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-ULT-15K',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-XLWF-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-ULT-15KP',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-XLWF-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-ULT-19.9K',
        activePower: 19.9,
        apparentPower: 19.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-XLWF-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-ULT-20K',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-XLWF-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-ULT-20KP',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-XLWF-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-ULT-25K',
        activePower: 24.9,
        apparentPower: 24.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-XLWF-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-ULT-30K',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-QI6J-0001',
        manufacturerName: 'EcoFlow Inc.',
        moduleType: 'EF HD-P3-29K9-S1',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-QI6J-0002',
        manufacturerName: 'EcoFlow Inc.',
        moduleType: 'EF HD-P3-25K0-S1',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-QI6J-0003',
        manufacturerName: 'EcoFlow Inc.',
        moduleType: 'EF HD-P3-20K0-S1',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-QI6J-0004',
        manufacturerName: 'EcoFlow Inc.',
        moduleType: 'EF HD-P3-15K0-S1',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-115R-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 17.5',
        activePower: 17.5,
        apparentPower: 17.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-115R-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 20.0',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-115R-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 22.0',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-115R-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 24.0',
        activePower: 24.0,
        apparentPower: 24.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-115R-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 15.0',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-J16H-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MGA-40K-G2',
        activePower: 40.0,
        apparentPower: 44.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1CTK-J16H-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MGA-50K-G2',
        activePower: 50.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1CTK-J16H-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MGA-60K-G2',
        activePower: 60.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1CTK-J16H-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MGA-40K-G2(L)',
        activePower: 40.0,
        apparentPower: 44.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1CTK-J16H-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MGA-50K-G2(L)',
        activePower: 50.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1CTK-J16H-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MGA-60K-G2(L)',
        activePower: 60.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-GP65-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'Q.VOLT-P80T-X',
        activePower: 80.0,
        apparentPower: 88.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-GP65-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'Q.VOLT-P100T-X',
        activePower: 100.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-GP65-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'Q.VOLT-P110T-X',
        activePower: 110.0,
        apparentPower: 121.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-GP65-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'Q.VOLT-P120T-X',
        activePower: 120.0,
        apparentPower: 132.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-GP65-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'Q.VOLT-P125T-X',
        activePower: 125.0,
        apparentPower: 132.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7CMF-BSDZ-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'RPI M30A_120',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-BSDZ-0002',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'RPI M30A_121',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0001',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H5A_220',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0002',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H5A_221',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0003',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H4A_220',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0004',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H4A_221',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0005',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H3A_220',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0006',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H3A_221',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0007',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H3_210',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0008',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H3_211',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0009',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H2.5_210',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7CMF-Z6DC-0010',
        manufacturerName: 'Delta Electronics, Inc.',
        moduleType: 'H2.5_211',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-HODP-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'I-X15',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-HODP-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'I-X12',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-HODP-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'I-X10',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-HODP-0004',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'I-X8',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-HODP-0005',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'I-X6',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-HODP-0006',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'I-X5',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0002',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-2',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0003',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-3',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0004',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-4',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0005',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-5',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0006',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-X E2',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0007',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-2 E2',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0008',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-3 E2',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0009',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-4 E2',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0010',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-5 E2',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-H48P-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP3.0-3AV-40',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-H48P-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP4.0-3AV-40',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-H48P-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP5.0-3AV-40',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-H48P-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP6.0-3AV-40',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-H48P-0005',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP8.0-3AV-40',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-H48P-0006',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP10.0-3AV-40',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-U84F-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SBSE3.6-50',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-U84F-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SBSE4.0-50',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-U84F-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SBSE5.0-50',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-U84F-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SBSE6.0-50',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-SO2R-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STPS50-20',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-SO2R-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STPS30-20',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-SO2R-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SI50-20',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-SO2R-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SI30-20',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-UY4C-TT6V-0001',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZAC',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-TT6V-0002',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZAC-M',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-TT6V-0003',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZAC-L',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-DDDY-0001',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZHI',
        activePower: 1.2,
        apparentPower: 1.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-DDDY-0002',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZHI-M',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-DDDY-0003',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZHI-L',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-UENU-0001',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZ1D-H',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-UENU-0002',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZ1D',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-UENU-0003',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZ1D-L',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3T96-0001',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'QT2D-H',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3T96-0002',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'QT2D',
        activePower: 3.2,
        apparentPower: 3.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3E2D-0001',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'DS3D',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3E2D-0002',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'DS3D-L',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3E2D-0003',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'DS3D-SH',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0001',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZ1-H',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0002',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'DS3-H',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0003',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'DS3',
        activePower: 0.9,
        apparentPower: 0.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0004',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZ1-M',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0005',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'DS3-M',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0006',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'DS3-L',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0007',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZ1-S',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0008',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'DS3-S',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0009',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'EZ1-SPE',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-3W4W-0010',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'DS3-L-SPE',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-UY4C-J1LM-0001',
        manufacturerName: 'ALTENERGY POWER SYSTEM INC.',
        moduleType: 'QT2',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-M82A-0002',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-12KW-3P-A-0-E3',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-M82A-0003',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-12KW-3P-A-2-E3',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-M82A-0004',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-12KW-3P-A-3-E3',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-M82A-0005',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-12KW-3P-A-4-E3',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-M82A-0006',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-12KW-3P-A-5-E3',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-M82A-0007',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-12KW-3P-A-6-E3',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-M82A-0008',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP-12KW-3P-A-7-E3',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-39WI-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STPS50-20',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-39WI-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STPS30-20',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-39WI-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SI50-20',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-39WI-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SI30-20',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-B2HU-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SB3.0-1AV-41',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-B2HU-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SB3.6-1AV-41',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-B2HU-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SB4.0-1AV-41',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-B2HU-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SB5.0-1AV-41',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-Z5Z7-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 25.0 NX3 M3 WM OD IIG0',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-Z5Z7-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 30.0 NX3 M3 WM OD IIG0',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-Z5Z7-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 33.0 NX3 M3 WM OD IIG0',
        activePower: 33.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-EXF9-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 25.0 NX3 M3 WM OD IIG0',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-EXF9-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 30.0 NX3 M3 WM OD IIG0',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-EXF9-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 33.0 NX3 M3 WM OD IIG0',
        activePower: 33.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-ID9J-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP5.0-3SE-40',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-ID9J-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP6.0-3SE-40',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-ID9J-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP8.0-3SE-40',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-ID9J-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP10.0-3SE-40',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-OR8Q-NQEC-0001',
        manufacturerName: 'Hager Vertriebs­ge­sell­schaft mbH & Co. KG',
        moduleType: 'XEM900 (flow R2) ',
        activePower: 12.0,
        apparentPower: 13.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-C5V3-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW8000-SDT-30',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-C5V3-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW10K-SDT-30',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-C5V3-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW10K-SDT-EU30',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-C5V3-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW12K-SDT-30',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-C5V3-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW15K-SDT-30',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-C5V3-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW17K-SDT-30',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-C5V3-0007',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW20K-SDT-30',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0001',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE3K',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0002',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE4K',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0003',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE5K',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0004',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE6K',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0005',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE7K',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0006',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE8K',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0007',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE9K',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0008',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE10K',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0009',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE12.5K',
        activePower: 12.5,
        apparentPower: 12.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0010',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE15K',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0011',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE16K',
        activePower: 16.0,
        apparentPower: 16.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0012',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE17K',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0013',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE3K-RWB',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0014',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE4K-RWB',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0015',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE5K-RWB',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0016',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE5K-RWS',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0017',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE7K-RWS',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0018',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE8K-RWS',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-HY5Z-0019',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE10K-RWS',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0004',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT400',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0005',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT450',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0006',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT500',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0007',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT560',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0008',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT600',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0009',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT660',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0010',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT700',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0011',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT720',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0012',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT800',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0013',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT800SE',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0014',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT1000',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0015',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT1200',
        activePower: 1.2,
        apparentPower: 1.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0003',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT360',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0002',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT350',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-6L5F-NFIF-0001',
        manufacturerName: 'AMPERE German Electric Innovation GmbH',
        moduleType: 'ASP 10KW-3P-X',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-SPMH-FWS9-0001',
        manufacturerName: 'Hycube Technologies GmbH',
        moduleType: 'HY-5K-TL-LV',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3000-ES-20',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600-ES-20',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000-ES-20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000-ES-20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3000-ES-AT20',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600-ES-AT20',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0007',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000-ES-AT20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0008',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000-ES-AT20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0009',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600M-ES-20',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0010',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000M-ES-20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0011',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000M-ES-20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0012',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600M-ES-AT20',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0013',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000M-ES-AT20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0014',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000M-ES-AT20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0015',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600-SBP-20',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0016',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000-SBP-20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0017',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000-SBP-20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0018',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600-SBP-AT20',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0019',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000-SBP-AT20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-URQO-0020',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000-SBP-AT20',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-BFCH-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5048D-ES',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-BFCH-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3648D-ES',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-BFCH-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5048D-ESA',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-RXUB-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW40K-SDT-P30',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-RXUB-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW25K-SDT-30',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-RXUB-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW30K-SDT-30',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-7X96-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW8000-SDT-20',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-7X96-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW10K-SDT-20',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-7X96-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW12K-SDT-20',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-7X96-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW15K-SDT-20',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-7X96-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW17K-SDT-20',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-7X96-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW20K-SDT-20',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-XDNY-0001',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT1600SE',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-XDNY-0002',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT1800SE',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-XDNY-0003',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT2000SE',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PZ0H-U1SH-0001',
        manufacturerName: 'Envertech (Shanghai) Corporation Ltd.',
        moduleType: 'EVT300',
        activePower: 0.3,
        apparentPower: 0.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-4KDR-RR3E-0001',
        manufacturerName: 'Kontron Solar GmbH',
        moduleType: 'StecaGrid 3213',
        activePower: 3.2,
        apparentPower: 3.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9FZG-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-PRO-8K-G2',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9FZG-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-PRO-10K-G2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9FZG-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-PRO-12K-G2',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9FZG-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-PRO-15K-G2',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9FZG-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-PRO-17K-G2',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9FZG-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-PRO-20K-G2',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9FZG-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-PRO-25K-G2',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9FZG-0008',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-PRO-30K-G2',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-XLOM-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-TRENE-100K',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0001',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 30KTL-D3/EU-CSB',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0002',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 30KTL-D3/EU',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0003',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 28KTL-D3/EU',
        activePower: 28.0,
        apparentPower: 28.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0004',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 25KTL-D3/EU',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0005',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 22KTL-D3/EU',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0006',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 20KTL-D3/EU',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0007',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 17KTL-D3/EU',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0008',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 30KTL-D3',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0009',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 28KTL-D3',
        activePower: 28.0,
        apparentPower: 28.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0010',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 25KTL-D3',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0011',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 22KTL-D3',
        activePower: 22.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0012',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 20KTL-D3',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-8PPZ-WYU6-0013',
        manufacturerName: 'Shenzhen Senergy Technology Co., Ltd.',
        moduleType: 'SE 17KTL-D3',
        activePower: 17.0,
        apparentPower: 17.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-6QX7-0001',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE5K-RWB48',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-6QX7-0002',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE7K-RWB48',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-6QX7-0003',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE8K-RWB48',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-6QX7-0004',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE10k-RWB48',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-VKMY-0001',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGS-3.6K',
        activePower: 3.6,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-VKMY-0002',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGS-4.2K',
        activePower: 4.2,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-VKMY-0003',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGS-5K',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-WIL7-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5K-ET',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-WIL7-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5KN-ET',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-WIL7-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6.5K-ET',
        activePower: 6.5,
        apparentPower: 6.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-WIL7-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6.5KN-ET',
        activePower: 6.5,
        apparentPower: 6.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-WIL7-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW8K-ET',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-WIL7-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW8KN-ET',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-WIL7-0007',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW10K-ET',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-WIL7-0008',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW10KN-ET',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-H69K-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5K-BT',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-H69K-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6K-BT',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-H69K-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW8K-BT',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-H69K-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW10K-BT',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K07-ETC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K06-ETC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K05-ETC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K07-ETC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K06-ETC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K05-ETC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0007',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K07-BTC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0008',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K06-BTC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0009',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K05-BTC',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0010',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K07-BTC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0011',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K06-BTC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-86II-0012',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW50K05-BTC',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-6NNI-0001',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-25K-100',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-6NNI-0002',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-30K-100',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-6NNI-0003',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-36K-100',
        activePower: 36.0,
        apparentPower: 36.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-6NNI-0004',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-40K-100',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-6NNI-0005',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-50K-100',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-6NNI-0006',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-40K-100-P',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-6NNI-0007',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-50K-100-P',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-MBO6-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3048-EM',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-MBO6-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3648-EM',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-MBO6-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5048-EM',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-UQQA-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW100K-HT',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-UQQA-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW110K-HT',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-UQQA-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW120K-HT',
        activePower: 120.0,
        apparentPower: 120.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-UQQA-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW136K-HTH',
        activePower: 136.0,
        apparentPower: 136.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000-ET-20',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW8000-ET-20',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW10K-ET-20',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW12K-ET-20',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW15K-ET-20',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000-BT-20',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0007',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW8000-BT-20',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0008',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW10K-BT-20',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0009',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW12K-BT-20',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-5DHS-0010',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW15K-BT-20',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600-EH',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000-EH',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000-EH',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0004',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600N-EH',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0005',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000N-EH',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0006',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000N-EH',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0007',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3K-BH',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0008',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3600-BH',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0009',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5000-BH',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-0DXI-0010',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW6000-BH',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-MDKU-0001',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3048-EM',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-MDKU-0002',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW3648-EM',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XBO0-MDKU-0003',
        manufacturerName: 'GoodWe Technologies Co., Ltd.',
        moduleType: 'GW5048-EM',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-D77X-5HI0-0001',
        manufacturerName: 'HagerEnergy GmbH',
        moduleType: 'S10 SE',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-D77X-AV41-0001',
        manufacturerName: 'HagerEnergy GmbH',
        moduleType: 'S10 X',
        activePower: 12.0,
        apparentPower: 13.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-D77X-MQVZ-0001',
        manufacturerName: 'HagerEnergy GmbH',
        moduleType: 'S10 E PRO',
        activePower: 12.0,
        apparentPower: 13.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-D77X-9Z0Q-0001',
        manufacturerName: 'HagerEnergy GmbH',
        moduleType: 'S10 E PRO COMPACT',
        activePower: 12.0,
        apparentPower: 13.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-D77X-K2A9-0001',
        manufacturerName: 'HagerEnergy GmbH',
        moduleType: 'S10 E COMPACT',
        activePower: 12.0,
        apparentPower: 13.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-D77X-41WQ-0001',
        manufacturerName: 'HagerEnergy GmbH',
        moduleType: 'S10 E INFINITY',
        activePower: 12.0,
        apparentPower: 13.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-D77X-36KX-0001',
        manufacturerName: 'HagerEnergy GmbH',
        moduleType: 'S10 E',
        activePower: 12.0,
        apparentPower: 13.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-D77X-48XT-0001',
        manufacturerName: 'HagerEnergy GmbH',
        moduleType: 'S10 MINI',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-1B4P-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'R110',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-1B4P-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'R100',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-1B4P-0000',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'R75',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-4TCE-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 125KTL-V4-A',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-4TCE-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 110KTL-V4',
        activePower: 110.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-4TCE-0000',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 100KTL-V4',
        activePower: 100.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DB92-MT1Y-0001',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 15000TL-V3',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-MT1Y-0002',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 17000TL-V3',
        activePower: 17.0,
        apparentPower: 18.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-MT1Y-0003',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 20000TL-V3',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-MT1Y-0004',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 22000TL-V3',
        activePower: 22.0,
        apparentPower: 24.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-DB92-MT1Y-0005',
        manufacturerName: 'Zucchetti Centro Sistemi SpA',
        moduleType: 'AZZURRO 3PH 24000TL-V3',
        activePower: 24.0,
        apparentPower: 26.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-W6PG-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'S3300-G2',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-W6PG-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'S3000-G2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-W6PG-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'S2500-G2',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-W6PG-0004',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'S2000-G2',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-W6PG-0005',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'S1500-G2',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-W6PG-0006',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'S1000-G2',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-W6PG-0007',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'S800-G2',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-W6PG-0008',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'S700-G2',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-W6PG-0009',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'S600-G2',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-X34Y-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 50-40',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-X34Y-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 50-41',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-002W-5ED5-0001',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power Storage DC 4.0',
        activePower: 4.0,
        apparentPower: 6.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-002W-5ED5-0002',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power Storage DC 5.0',
        activePower: 5.0,
        apparentPower: 6.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-002W-5ED5-0003',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power Storage DC 6.0',
        activePower: 6.0,
        apparentPower: 6.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-002W-5ED5-0004',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power Storage AC 4.0',
        activePower: 4.0,
        apparentPower: 6.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-002W-5ED5-0005',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power Storage AC 6.0',
        activePower: 6.0,
        apparentPower: 6.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-002W-5ED5-0006',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power Inverter 4.0',
        activePower: 4.0,
        apparentPower: 6.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-002W-5ED5-0007',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power Inverter 5.0',
        activePower: 5.0,
        apparentPower: 6.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-002W-5ED5-0008',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power  Inverter 6.0',
        activePower: 6.0,
        apparentPower: 6.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0001',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-5K',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0002',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-6K',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0003',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-8K',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0004',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-8K-P',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0005',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-10K',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0006',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-10K-P',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0007',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-12K',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0008',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-12K-P',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0009',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-15K',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0010',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-15K-P',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0011',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-20K',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-FIHY-0012',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'OGT-25K',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0001',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-4K-25',
        activePower: 4.0,
        apparentPower: 4.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0002',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-5K-25',
        activePower: 5.0,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0003',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-6K-25',
        activePower: 6.0,
        apparentPower: 6.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0004',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-8K-25',
        activePower: 8.0,
        apparentPower: 8.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0005',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-10K-25',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0006',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-12K-25',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0007',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-10K-40',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0008',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-12K-40',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0009',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-15K-40',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XFYS-4VKH-0010',
        manufacturerName: 'Wuxi Solinteg Power Co., Ltd.',
        moduleType: 'MHT-20K-40',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-T3PX-YLQH-0001',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG75CX-P2',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-YLQH-0002',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG110CX-P2',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-YLQH-0003',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG125CX-P2',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-KTPY-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-250K-EHV-5G',
        activePower: 250.0,
        apparentPower: 250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-KTPY-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-255K-EHV-5G',
        activePower: 255.0,
        apparentPower: 255.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-KTPY-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-215K-EHV-5G-PLUS',
        activePower: 215.0,
        apparentPower: 215.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-KTPY-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-250K-EHV-5G-PLUS',
        activePower: 250.0,
        apparentPower: 250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-KTPY-0005',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-255K-EHV-5G-PLUS',
        activePower: 255.0,
        apparentPower: 255.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-1CZT-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 92.0 TL3-S B1 WM OD IIGM',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-1CZT-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 92.0 TL3-S B1 WM OD IIGL',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-1CZT-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 92.0 TL3-S B1 WM OD IIGX',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-1CZT-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 110 TL3-S B1 WM OD IIKM',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-1CZT-0005',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 110 TL3-S B1 WM OD IIKL',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-1CZT-0006',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 110 TL3-S B1 WM OD IIKX',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-1CZT-0007',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 137 TL3-S B1 WM OD IIPM',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-1CZT-0008',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 137 TL3-S B1 WM OD IIPL',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-1CZT-0009',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 137 TL3-S B1 WM OD IIPX',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-9GR9-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 92.0 TL3-S B1 WM OD IIGM',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-9GR9-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 92.0 TL3-S B1 WM OD IIGL',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-9GR9-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 92.0 TL3-S B1 WM OD IIGX',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-9GR9-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 110 TL3-S B1 WM OD IIKM',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-9GR9-0005',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 110 TL3-S B1 WM OD IIKL',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-9GR9-0006',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 110 TL3-S B1 WM OD IIKX',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-9GR9-0007',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 137 TL3-S B1 WM OD IIPM',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-9GR9-0008',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 137 TL3-S B1 WM OD IIPL',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-9GR9-0009',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet gs 137 TL3-S B1 WM OD IIPX',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-OZBS-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 25-50',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-OZBS-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 20-50',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-OZBS-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 15-50',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-X3NN-C3AW-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'STP 110-60',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-002W-1XEN-0001',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power Storage DC 8.0',
        activePower: 8.0,
        apparentPower: 10.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-002W-1XEN-0002',
        manufacturerName: 'RCT Power GmbH',
        moduleType: 'Power Storage DC 10.0',
        activePower: 9.9,
        apparentPower: 10.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-XJAN-0001',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE25K',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-XJAN-0002',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE27.6K',
        activePower: 27.6,
        apparentPower: 27.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-XJAN-0003',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE30K',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-NZT3-XJAN-0004',
        manufacturerName: 'SolarEdge Technologies GmbH',
        moduleType: 'SE33K',
        activePower: 33.3,
        apparentPower: 33.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 87.0 TL3 M1 WM OD IIF0',
        activePower: 87.0,
        apparentPower: 87.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 87.0 TL3 M1 WM OD IIFX',
        activePower: 87.0,
        apparentPower: 87.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 92.0 TL3 M1 WM OD IIG0',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 92.0 TL3 M1 WM OD IIGX',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0005',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 105 TL3 M1 WM OD IIG0',
        activePower: 99.9,
        apparentPower: 99.9,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0006',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 105 TL3 M1 WM OD IIGX',
        activePower: 99.9,
        apparentPower: 99.9,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0007',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 110 TL3 M1 WM OD IIK0',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0008',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 110 TL3 M1 WM OD IIKX',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0009',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 125 TL3 M1 WM OD IIP0',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0010',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 125 TL3 M1 WM OD IIPX',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0011',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 125 TL3 M1 WM OD IIK0',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0012',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 125 TL3 M1 WM OD IIKX',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0013',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 137 TL3 M1 WM OD IIP0',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0014',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 137 TL3 M1 WM OD IIPX',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0015',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 150 TL3 M1 WM OD IIQ0',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0016',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 150 TL3 M1 WM OD IIQX',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0017',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 155 TL3 M1 WM OD IIP0',
        activePower: 155.0,
        apparentPower: 155.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0018',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 155 TL3 M1 WM OD IIPX',
        activePower: 155.0,
        apparentPower: 155.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0019',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 165 TL3 M1 WM OD IIQ0',
        activePower: 165.0,
        apparentPower: 165.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YLRY-0020',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 165 TL3 M1 WM OD IIQX',
        activePower: 165.0,
        apparentPower: 165.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 87.0 TL3 M1 WM OD IIF0',
        activePower: 87.0,
        apparentPower: 87.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 87.0 TL3 M1 WM OD IIFX',
        activePower: 87.0,
        apparentPower: 87.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 92.0 TL3 M1 WM OD IIG0',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 92.0 TL3 M1 WM OD IIGX',
        activePower: 92.0,
        apparentPower: 92.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0005',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 105 TL3 M1 WM OD IIG0',
        activePower: 99.9,
        apparentPower: 99.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0006',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 105 TL3 M1 WM OD IIGX',
        activePower: 99.9,
        apparentPower: 99.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0007',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 110 TL3 M1 WM OD IIK0',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0008',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 110 TL3 M1 WM OD IIKX',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0009',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 125 TL3 M1 WM OD IIP0',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0010',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 125 TL3 M1 WM OD IIPX',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0011',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 125 TL3 M1 WM OD IIK0',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0012',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 125 TL3 M1 WM OD IIKX',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0013',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 137 TL3 M1 WM OD IIP0',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0014',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 137 TL3 M1 WM OD IIPX',
        activePower: 137.0,
        apparentPower: 137.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0015',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 150 TL3 M1 WM OD IIQ0',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0016',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 150 TL3 M1 WM OD IIQX',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0017',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 155 TL3 M1 WM OD IIP0',
        activePower: 155.0,
        apparentPower: 155.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0018',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 155 TL3 M1 WM OD IIPX',
        activePower: 155.0,
        apparentPower: 155.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0019',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 165 TL3 M1 WM OD IIQ0',
        activePower: 165.0,
        apparentPower: 165.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-3A7Y-0020',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 165 TL3 M1 WM OD IIQX',
        activePower: 165.0,
        apparentPower: 165.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-50K-LV-5G',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC50K-LV',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-60K-LV-5G',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0004',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC60K-LV',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0005',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-80K-5G',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0006',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC-80K',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0007',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-100K-5G',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0008',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC-100K',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0009',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-110K-5G',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0010',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'S5-GC-110K',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0011',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-100K-HV-5G',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0012',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-110K-BHV-5G',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-7S0P-0013',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-125K-HV-5G',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-3.0-D',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-3.0-M',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-3.7-D',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-3.7-M',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-4.6-D',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-4.6-M',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-5.0-D',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0008',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-5.0-M',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0009',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-6.0-D',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0010',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-6.0-M',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0011',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-7.5-D',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0012',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Hybrid-7.5-M',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0013',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-3.0-M',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0014',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-3.0-W',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0015',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-3.7-M',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0016',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-3.7-W',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0017',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-4.6-M',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0018',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-4.6-W',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0019',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-5.0-M',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0020',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-5.0-W',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0021',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-6.0-M',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0022',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-6.0-W',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0023',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-7.5-M',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-LBJC-0024',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Fit-7.5-W',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-X8WQ-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet gs 50.0 TL3-S B1 WM OD IIGL',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-X8WQ-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet gs 50.0 TL3-S B1 WM OD IIGX',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-X8WQ-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet gs 50.0 TL3-S B1 WM OD IIGB',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-X8WQ-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet gs 50.0 TL3-S B1 WM OD IIGM',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1CTK-6KJD-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-MINI-0.6K-G4',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-6KJD-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-MINI-0.7K-G4',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-6KJD-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-MINI-0.8K-G4',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-6KJD-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-MINI-1.1K-G4',
        activePower: 1.1,
        apparentPower: 1.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-6KJD-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-MINI-1.5K-G4',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-6KJD-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-MINI-2.0K-G4',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-6KJD-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-MINI-2.5K-G4',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-6KJD-0008',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-MINI-3.0K-G4',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-6KJD-0009',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-MINI-3.3K-G4',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-4MC2-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO MP plus 1.5-1',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-4MC2-0002',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO MP plus 2.0-1',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-4MC2-0003',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO MP plus 2.5-1',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-4MC2-0004',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO MP plus 3.0-1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-4MC2-0005',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO MP plus 3.0-2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-4MC2-0006',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO MP plus 3.6-1',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-4MC2-0007',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO MP plus 3.6-2',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-4MC2-0008',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO MP plus 4.6-2',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-4MC2-0009',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO MP plus 5.0-2',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-IBOO-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet gs 50.0 TL3-S B1 WM OD IIGL',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-IBOO-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet gs 50.0 TL3-S B1 WM OD IIGX',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-IBOO-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet gs 50.0 TL3-S B1 WM OD IIGB',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-IBOO-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet gs 50.0 TL3-S B1 WM OD IIGM',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-YH34-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MIC-3K-G2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-YH34-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MIC-4K-G2',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-YH34-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MIC-5K-G2',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-YH34-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MIC-6K-G2',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-YH34-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MIC-8K-G2',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-YH34-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MIC-10K-G2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-YH34-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MIC-12K-G2',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-YH34-0008',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MIC-15K-G2',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-4K',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-5K',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-6K',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-8K',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-10K',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-12K',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-N8VO-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-IES-15K',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-I9G1-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Boost-2.5K-G4',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-I9G1-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Boost-3.0K-G4',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-I9G1-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Boost-3.3K-G4',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-I9G1-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Boost-3.6K-G4',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-I9G1-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Boost-4.2K-G4',
        activePower: 4.2,
        apparentPower: 4.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-I9G1-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Boost-5.0K-G4',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 3.0',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0002',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 4.2',
        activePower: 4.2,
        apparentPower: 4.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0003',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 5.5',
        activePower: 5.5,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0004',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 7.0',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0005',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 8.5',
        activePower: 8.5,
        apparentPower: 8.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0006',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 10',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0007',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO IQ 3.0',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0008',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO IQ 4.2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0009',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO IQ 5.5',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0010',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO IQ 7.0',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0011',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO IQ 8.5',
        activePower: 8.5,
        apparentPower: 8.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-K8S0-0012',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO IQ 10.0',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-DQS6-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE BI 5.5/26',
        activePower: 5.5,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-DQS6-0002',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE BI 10/26',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-GMYU-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE BI 5.5/26 G2',
        activePower: 5.5,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-GMYU-0002',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE BI 10/26 G2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-UGSH-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SHP 100-20',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-UGSH-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SHP 150-20',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-UGSH-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SHP 100-21',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-UGSH-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SHP 150-21',
        activePower: 150.0,
        apparentPower: 150.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-UGSH-0005',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SHP 172-21',
        activePower: 172.0,
        apparentPower: 172.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-UGSH-0006',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SHP 180-21',
        activePower: 180.0,
        apparentPower: 180.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-OLVY-0002',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-100K-5G-PRO',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-OLVY-0003',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-80K-5G-PRO',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-DFN7-OLVY-0001',
        manufacturerName: 'Ginlong technologies Co., Ltd.',
        moduleType: 'Solis-110K-5G-PRO',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-03XE-PLK9-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 3.0 G2',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-PLK9-0002',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 4.2 G2',
        activePower: 4.2,
        apparentPower: 4.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-PLK9-0003',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 5.5 G2',
        activePower: 5.5,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-PLK9-0004',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 7.0 G2',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-PLK9-0005',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 8.5 G2',
        activePower: 8.5,
        apparentPower: 8.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-PLK9-0006',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PLENTICORE plus 10 G2',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-031I-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO CI 30',
        activePower: 30.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1IRH-K5ZY-0001',
        manufacturerName: 'Vision UPS Systems S.à.r.l',
        moduleType: 'batterX h10',
        activePower: 9.9,
        apparentPower: 9.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0008',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 60.0 TL3 M1 WM OD FRGX',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0009',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 60.0 TL3 M1 WM OD IIGX',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0010',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 60.0 TL3 M1 WM OD IIGB',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0011',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 60.0 TL3 M1 WM OD IIGM',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD IIGX',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD FRGX',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0005',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD IIGS',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0006',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD HUGM',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0007',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD HUGX',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD IIGB',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-N29R-01A8-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Eco 27.0-3-S',
        activePower: 27.0,
        apparentPower: 27.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-N29R-01A8-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Eco 25.0-3-S',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YBJF-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD IIGM',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1CTK-TBEE-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-80K',
        activePower: 80.0,
        apparentPower: 80.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-TBEE-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-100K',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-TBEE-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-110K',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-TBEE-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-120K',
        activePower: 120.0,
        apparentPower: 120.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-TBEE-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-FTH-125K',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-5.0-M',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-5.0-D',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-6.0-M',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-6.0-D',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-8.0-M',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-8.0-D',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-10.0-M',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0008',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-10.0-D',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0009',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-12.0-M',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0010',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-12.0-D',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0011',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-15.0-M',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0012',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Hybrid-15.0-D',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0013',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-6.0-M',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0014',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-6.0-W',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0015',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-8.0-M',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0016',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-8.0-W',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0017',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-10.0-M',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0018',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-10.0-W',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0019',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-15.0-M',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-PSS4-0020',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-Fit-15.0-W',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-5SH9-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-HYB-4.0-P',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-5SH9-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-HYB-5.0-P',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-5SH9-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-HYB-6.0-P',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-5SH9-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-HYB-8.0-P',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-5SH9-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-HYB-10.0-P',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-5SH9-0006',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-HYB-12.0-P',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-5SH9-0007',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-HYB-15.0-P',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-0ACO-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-AELIO-50K',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-0ACO-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-AELIO-60K',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-0ACO-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-AELIO-49.9K',
        activePower: 49.9,
        apparentPower: 49.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-0ACO-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-AELIO-61K',
        activePower: 61.0,
        apparentPower: 61.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-0ACO-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-AELIO-49.9K-P',
        activePower: 49.9,
        apparentPower: 49.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-P3CQ-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Micro 750',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-P3CQ-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Micro 800',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-P3CQ-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Micro 900',
        activePower: 0.9,
        apparentPower: 0.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-P3CQ-0004',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Micro 1000',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-P3CQ-0005',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X1-Micro 1200',
        activePower: 1.2,
        apparentPower: 1.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-UAR6-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD IIGB',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-UAR6-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD IIGX',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-UAR6-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD IIGS',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PW4Z-J60F-0001',
        manufacturerName: 'Victron Energy BV',
        moduleType: 'Easysolar-II 48/3000/35-32 MPPT 250/70 GX',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PW4Z-J60F-0002',
        manufacturerName: 'Victron Energy BV',
        moduleType: 'Easysolar-II 24/3000/70-32 MPPT 250/70 GX',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PW4Z-J60F-0003',
        manufacturerName: 'Victron Energy BV',
        moduleType: 'Easysolar-II 48/5000/70-50 MPPT 250/100 GX',
        activePower: 4.4,
        apparentPower: 4.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PW4Z-0RIR-0001',
        manufacturerName: 'Victron Energy BV',
        moduleType: 'Multi RS Solar 48/6000/100-450/100',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PW4Z-KAZ8-0001',
        manufacturerName: 'Victron Energy BV',
        moduleType: 'Quattro-II 48/5000/70-50/50 230V',
        activePower: 4.4,
        apparentPower: 4.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0001',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1000-PV-1-550-5',
        activePower: 1000.0,
        apparentPower: 1000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0002',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2000-PV-2-550-5',
        activePower: 2000.0,
        apparentPower: 2000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0003',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3000-PV-3-550-5',
        activePower: 3000.0,
        apparentPower: 3000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0004',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4000-PV-4-550-5',
        activePower: 4000.0,
        apparentPower: 4000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0005',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1045-PV-1-575-5',
        activePower: 1045.0,
        apparentPower: 1045.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0006',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2090-PV-2-575-5',
        activePower: 2090.0,
        apparentPower: 2090.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0007',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3135-PV-3-575-5',
        activePower: 3135.0,
        apparentPower: 3135.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0008',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4180-PV-4-575-5',
        activePower: 4180.0,
        apparentPower: 4180.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0009',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1090-PV-1-600-5',
        activePower: 1090.0,
        apparentPower: 1090.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0010',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2180-PV-2-600-5',
        activePower: 2180.0,
        apparentPower: 2180.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0011',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3270-PV-3-600-5',
        activePower: 3270.0,
        apparentPower: 3270.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0012',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4360-PV-4-600-5',
        activePower: 4360.0,
        apparentPower: 4360.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0013',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1140-PV-1-630-5',
        activePower: 1140.0,
        apparentPower: 1140.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0014',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2280-PV-2-630-5',
        activePower: 2280.0,
        apparentPower: 2280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0015',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3420-PV-3-630-5',
        activePower: 3420.0,
        apparentPower: 3420.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0016',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4560-PV-4-630-5',
        activePower: 4560.0,
        apparentPower: 4560.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0017',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1200-PV-1-660-5',
        activePower: 1200.0,
        apparentPower: 1200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0018',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2400-PV-2-660-5',
        activePower: 2400.0,
        apparentPower: 2400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0019',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3600-PV-3-660-5',
        activePower: 3600.0,
        apparentPower: 3600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0020',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4800-PV-4-660-5',
        activePower: 4800.0,
        apparentPower: 4800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0021',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1250-PV-1-690-5',
        activePower: 1250.0,
        apparentPower: 1250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0022',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2500-PV-2-690-5',
        activePower: 2500.0,
        apparentPower: 2500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0023',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3750-PV-3-690-5',
        activePower: 3750.0,
        apparentPower: 3750.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0024',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS5000-PV-4-690-5',
        activePower: 5000.0,
        apparentPower: 5000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0025',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS600-ES-1-330-5',
        activePower: 600.0,
        apparentPower: 600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0026',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1200-ES-2-330-5',
        activePower: 1200.0,
        apparentPower: 1200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0027',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1800-ES-3-330-5',
        activePower: 1800.0,
        apparentPower: 1800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0028',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2400-ES-4-330-5',
        activePower: 2400.0,
        apparentPower: 2400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0029',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS650-ES-1-360-5',
        activePower: 650.0,
        apparentPower: 650.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0030',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1300-ES-2-360-5',
        activePower: 1300.0,
        apparentPower: 1300.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0031',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1950-ES-3-360-5',
        activePower: 1950.0,
        apparentPower: 1950.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0032',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2600-ES-4-360-5',
        activePower: 2600.0,
        apparentPower: 2600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0033',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS725-ES-1-400-5',
        activePower: 725.0,
        apparentPower: 725.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0034',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1450-ES-2-400-5',
        activePower: 1450.0,
        apparentPower: 1450.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0035',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2175-ES-3-400-5',
        activePower: 2175.0,
        apparentPower: 2175.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0036',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2900-ES-4-400-5',
        activePower: 2900.0,
        apparentPower: 2900.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0037',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS800-ES-1-440-5',
        activePower: 800.0,
        apparentPower: 800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0038',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1600-ES-2-440-5',
        activePower: 1600.0,
        apparentPower: 1600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0039',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2400-ES-3-440-5',
        activePower: 2400.0,
        apparentPower: 2400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0040',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3200-ES-4-440-5',
        activePower: 3200.0,
        apparentPower: 3200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0041',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS870-ES-1-480-5',
        activePower: 870.0,
        apparentPower: 870.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0042',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1740-ES-2-480-5',
        activePower: 1740.0,
        apparentPower: 1740.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0043',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2610-ES-3-480-5',
        activePower: 2610.0,
        apparentPower: 2610.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0044',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3480-ES-4-480-5',
        activePower: 3480.0,
        apparentPower: 3480.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0045',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS945-ES-1-520-5',
        activePower: 945.0,
        apparentPower: 945.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0046',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1890-ES-2-520-5',
        activePower: 1890.0,
        apparentPower: 1890.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0047',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2835-ES-3-520-5',
        activePower: 2835.0,
        apparentPower: 2835.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0048',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3780-ES-4-520-5',
        activePower: 3780.0,
        apparentPower: 3780.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0049',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1000-ES-1-550-5',
        activePower: 1000.0,
        apparentPower: 1000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0050',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2000-ES-2-550-5',
        activePower: 2000.0,
        apparentPower: 2000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0051',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3000-ES-3-550-5',
        activePower: 3000.0,
        apparentPower: 3000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0052',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4000-ES-4-550-5',
        activePower: 4000.0,
        apparentPower: 4000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0053',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1045-ES-1-575-5',
        activePower: 1045.0,
        apparentPower: 1045.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0054',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2090-ES-2-575-5',
        activePower: 2090.0,
        apparentPower: 2090.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0055',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3135-ES-3-575-5',
        activePower: 3135.0,
        apparentPower: 3135.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0056',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4180-ES-4-575-5',
        activePower: 4180.0,
        apparentPower: 4180.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0057',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1090-ES-1-600-5',
        activePower: 1090.0,
        apparentPower: 1090.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0058',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2180-ES-2-600-5',
        activePower: 2180.0,
        apparentPower: 2180.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0059',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3270-ES-3-600-5',
        activePower: 3270.0,
        apparentPower: 3270.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0060',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4360-ES-4-600-5',
        activePower: 4360.0,
        apparentPower: 4360.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0061',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1140-ES-1-630-5',
        activePower: 1140.0,
        apparentPower: 1140.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0062',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2280-ES-2-630-5',
        activePower: 2280.0,
        apparentPower: 2280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0063',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3420-ES-3-630-5',
        activePower: 3420.0,
        apparentPower: 3420.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0064',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4560-ES-4-630-5',
        activePower: 4560.0,
        apparentPower: 4560.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0065',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1200-ES-1-660-5',
        activePower: 1200.0,
        apparentPower: 1200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0066',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2400-ES-2-660-5',
        activePower: 2400.0,
        apparentPower: 2400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0067',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3600-ES-3-660-5',
        activePower: 3600.0,
        apparentPower: 3600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0068',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS4800-ES-4-660-5',
        activePower: 4800.0,
        apparentPower: 4800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0069',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS1250-ES-1-690-5',
        activePower: 1250.0,
        apparentPower: 1250.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0070',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS2500-ES-2-690-5',
        activePower: 2500.0,
        apparentPower: 2500.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0071',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS3750-ES-3-690-5',
        activePower: 3750.0,
        apparentPower: 3750.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-6IZV-0072',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'APS5000-ES-4-690-5',
        activePower: 5000.0,
        apparentPower: 5000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-PW4Z-QE63-0001',
        manufacturerName: 'Victron Energy BV',
        moduleType: 'Multiplus-II 48/3000/35-32',
        activePower: 2.4,
        apparentPower: 2.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PW4Z-QE63-0002',
        manufacturerName: 'Victron Energy BV',
        moduleType: 'Multiplus-II 48/5000/70-50',
        activePower: 4.2,
        apparentPower: 4.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PW4Z-QE63-0003',
        manufacturerName: 'Victron Energy BV',
        moduleType: 'Multiplus-II 24/3000/70-32',
        activePower: 2.5,
        apparentPower: 2.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9UZB-0001',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MGA-60K-G2',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9UZB-0002',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MGA-50K-G2',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1CTK-9UZB-0003',
        manufacturerName: 'SolaX Power Network Technology (Zhejiang) Co., Ltd.',
        moduleType: 'X3-MGA-40K-G2',
        activePower: 40.0,
        apparentPower: 40.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-UAR6-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'KACO blueplanet 50.0 TL3 M1 WM OD IIGM',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0001',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS4780-PV-4-440-5',
        activePower: 4780.0,
        apparentPower: 4780.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0002',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3260-PV-2-600-5',
        activePower: 3260.0,
        apparentPower: 3260.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0003',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6520-PV-4-600-5',
        activePower: 6520.0,
        apparentPower: 6520.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0004',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3430-PV-2-630-5',
        activePower: 3430.0,
        apparentPower: 3430.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0005',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6860-PV-4-630-5',
        activePower: 6860.0,
        apparentPower: 6860.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0006',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3590-PV-2-660-5',
        activePower: 3590.0,
        apparentPower: 3590.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0007',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS7180-PV-4-660-5',
        activePower: 7180.0,
        apparentPower: 7180.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0008',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3750-PV-2-690-5',
        activePower: 3750.0,
        apparentPower: 3750.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0009',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS7500-PV-4-690-5',
        activePower: 7500.0,
        apparentPower: 7500.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0010',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS4780-ES-4-440-5',
        activePower: 4780.0,
        apparentPower: 4780.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0011',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3130-ES-2-575-5',
        activePower: 3130.0,
        apparentPower: 3130.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0012',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6260-ES-4-575-5',
        activePower: 6260.0,
        apparentPower: 6260.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0013',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3260-ES-2-600-5',
        activePower: 3260.0,
        apparentPower: 3260.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0014',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6520-ES-4-600-5',
        activePower: 6520.0,
        apparentPower: 6520.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0015',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3430-ES-2-630-5',
        activePower: 3430.0,
        apparentPower: 3430.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0016',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS6860-ES-4-630-5',
        activePower: 6860.0,
        apparentPower: 6860.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0017',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3590-ES-2-660-5',
        activePower: 3590.0,
        apparentPower: 3590.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0018',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS7180-ES-4-660-5',
        activePower: 7180.0,
        apparentPower: 7180.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0019',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS3750-ES-2-690-5',
        activePower: 3750.0,
        apparentPower: 3750.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-AFK6-N7CJ-0020',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'MCS7500-ES-4-690-5',
        activePower: 7500.0,
        apparentPower: 7500.0,
        connectionRulesTypes: [],
    },
    {
        zerezId: 'ZE-T3PX-LJGZ-0001',
        manufacturerName: 'Guangzhou Sanjing Electric Co., Ltd.',
        moduleType: 'C6-75K-T6-40',
        activePower: 75.0,
        apparentPower: 75.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-LJGZ-0002',
        manufacturerName: 'Guangzhou Sanjing Electric Co., Ltd.',
        moduleType: 'C6-100K-T9-40',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-LJGZ-0003',
        manufacturerName: 'Guangzhou Sanjing Electric Co., Ltd.',
        moduleType: 'C6-110K-T12-40',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-T3PX-LJGZ-0004',
        manufacturerName: 'Guangzhou Sanjing Electric Co., Ltd.',
        moduleType: 'C6-125K-T12-40',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-03XE-GHV0-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO CI 50',
        activePower: 50.0,
        apparentPower: 55.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-GHV0-0002',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO CI 60',
        activePower: 60.0,
        apparentPower: 66.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-EOCS-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 125 NX3 M8 WM OD IIGM',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-EOCS-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 100 NX3 M8 WM OD IIGX',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-EOCS-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 100 NX3 M8 WM OD IIGM',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-EOCS-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 125 NX3 M10 WM OD IIGX',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MT67-YTOD-0003',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 100 NX3 M8 WM OD IIGX',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-YTOD-0004',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 100 NX3 M8 WM OD IIGM',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-YTOD-0002',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 125 NX3 M10 WM OD IIGM',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MT67-YTOD-0001',
        manufacturerName: 'KACO new energy GmbH',
        moduleType: 'blueplanet 125 NX3 M10 WM OD IIGX',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-40VT-5A7H-0002',
        manufacturerName: 'sonnen GmbH',
        moduleType: 'sonnenBatterie 10/5.5',
        activePower: 3.4,
        apparentPower: 3.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XAGL-LCGN-0002',
        manufacturerName: 'Viessmann Climate Solutions SE',
        moduleType: 'Vitocharge VX3 Typ 8.0A',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XAGL-HD9T-0001',
        manufacturerName: 'Viessmann Climate Solutions SE',
        moduleType: 'Vitocharge VX3 Typ 4.6A',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1OFQ-2VDT-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo Advanced 17.5-3-M',
        activePower: 17.5,
        apparentPower: 17.5,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1OFQ-2VDT-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo Advanced 20.0-3-M',
        activePower: 20.0,
        apparentPower: 20.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1OFQ-HX8E-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro 50-3-D',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1OFQ-U8R4-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 99-3-P',
        activePower: 99.9,
        apparentPower: 99.9,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1OFQ-U8R4-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 99-3-D',
        activePower: 99.9,
        apparentPower: 99.9,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1OFQ-U8R4-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 50-3-P',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1OFQ-U8R4-0006',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 50-3-D',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1OFQ-U8R4-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 100-3-D',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-N29R-GF3K-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo 3.0-1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-GF3K-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo 3.5-1',
        activePower: 3.5,
        apparentPower: 3.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-GF3K-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo 3.6-1',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-GF3K-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo 4.0-1',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-GF3K-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo 4.6-1',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-GF3K-0006',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo 5.0-1',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 6.0 SC ',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 6.0 Plus SC ',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 7.0 SC ',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 7.0 Plus SC ',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 8.0 SC ',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0006',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo GEN24 8.0 Plus SC ',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0007',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo GEN24 9.0 SC ',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0008',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo GEN24 9.0 Plus SC ',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0009',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo GEN24 10.0 SC ',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0010',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo GEN24 10.0 Plus SC ',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0011',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo GEN24 11.0 SC ',
        activePower: 11.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0012',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo GEN24 11.0 Plus SC ',
        activePower: 11.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0013',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo GEN24 12.0 SC ',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-WNM2-0014',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo GEN24 12.0 Plus SC ',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 6.0',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 6.0 Plus',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 7.0',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 7.0 Plus',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 8.0',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0006',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 8.0 Plus',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0007',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 9.0',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0008',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 9.0 Plus',
        activePower: 9.0,
        apparentPower: 9.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0009',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 10.0',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-EDZF-0010',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 10.0 Plus',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN 24 3.6',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 3.6 Plus',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 3.0 Plus',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 4.0 ',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0006',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 4.0 Plus',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0007',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 4.6',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0008',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 4.6 Plus',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0009',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 5.0',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0010',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 5.0 Plus',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0011',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 6.0',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0012',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 6.0 Plus',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-R3F3-UGD7-0001',
        manufacturerName: 'Hopewind Electric Co., Ltd.',
        moduleType: 'HSNV 100K-G01',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-R3F3-UGD7-0002',
        manufacturerName: 'Hopewind Electric Co., Ltd.',
        moduleType: 'HSNV 110K-G01',
        activePower: 110.0,
        apparentPower: 110.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-40VT-5A7H-0001',
        manufacturerName: 'sonnen GmbH',
        moduleType: 'sonnenBatterie 10',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-0PVI-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 20.0-3-M',
        activePower: 20.1,
        apparentPower: 20.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-0PVI-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 17.5-3-M',
        activePower: 17.6,
        apparentPower: 17.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-0PVI-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 15.0-3-M',
        activePower: 15.1,
        apparentPower: 15.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-0PVI-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 12.5-3-M',
        activePower: 12.5,
        apparentPower: 12.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-0PVI-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 10.0-3-M',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QF4W-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo Advanced 10.0-3-M',
        activePower: 10.1,
        apparentPower: 10.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QF4W-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo Advanced 12.5-3-M',
        activePower: 12.7,
        apparentPower: 12.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QF4W-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo Advanced 15.0-3-M',
        activePower: 15.3,
        apparentPower: 15.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QF4W-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo Advanced 17.5-3-M',
        activePower: 17.8,
        apparentPower: 17.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QF4W-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo Advanced 20.0-3-M',
        activePower: 20.3,
        apparentPower: 20.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-03XE-GPFU-0001',
        manufacturerName: 'KOSTAL Industrie Elektrik GmbH & Co. KG',
        moduleType: 'PIKO CI 30',
        activePower: 30.0,
        apparentPower: 33.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XAGL-F4MC-0001',
        manufacturerName: 'Viessmann Climate Solutions SE',
        moduleType: 'Vitocharge VX3 Typ 6.0B',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XAGL-F4MC-0002',
        manufacturerName: 'Viessmann Climate Solutions SE',
        moduleType: 'Vitocharge VX3 Typ 8.0B',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XAGL-LCGN-0001',
        manufacturerName: 'Viessmann Climate Solutions SE',
        moduleType: 'Vitocharge VX3 Typ 6.0A',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-R15F-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro 50-3-D',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-R15F-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro 50-3-P',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-R15F-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 50-3-D',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-R15F-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 50-3-P',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-R15F-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 99-3-D',
        activePower: 99.9,
        apparentPower: 99.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-R15F-0006',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 99-3-P',
        activePower: 99.9,
        apparentPower: 99.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-R15F-0007',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 100-3-D',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-R15F-0008',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 100-3-P',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-HG3Q-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 25.0',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-HG3Q-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 27.0',
        activePower: 27.0,
        apparentPower: 27.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-HG3Q-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 29.9',
        activePower: 29.9,
        apparentPower: 29.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-HG3Q-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 30.0',
        activePower: 30.0,
        apparentPower: 30.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-HG3Q-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Verto 33.3',
        activePower: 33.3,
        apparentPower: 33.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-2I5F-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Eco 27.0-3-S',
        activePower: 27.0,
        apparentPower: 27.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-2I5F-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Eco 25.0-3-S',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 3.0-3-M',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 3.7-3-M',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 5.0-3-M',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 4.5-3-M',
        activePower: 4.5,
        apparentPower: 4.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 5.5-3-M',
        activePower: 5.5,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0006',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 6.0-3-M',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0007',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 6.7-3-M',
        activePower: 6.7,
        apparentPower: 6.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0008',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 7.0-3-M',
        activePower: 7.0,
        apparentPower: 7.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0009',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo 8.0-3-M',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-QMK8-0010',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: ' Symo 8.2-3-M',
        activePower: 8.2,
        apparentPower: 8.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-624V-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 3.0',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-624V-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 4.0',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-624V-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 5.0',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-624V-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 3.0 Plus',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-624V-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 4.0 Plus',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-624V-0006',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo GEN24 5.0 Plus',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-PDMI-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Primo GEN24 3.0  ',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-1OFQ-2VDT-0000',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Symo Advanced 15.0-3-M',
        activePower: 15.0,
        apparentPower: 15.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1OFQ-U8R4-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro Eco 100-3-P',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-1OFQ-HX8E-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Tauro 50-3-P',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-EPYL-0F8R-0001',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS2000',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-0F8R-0002',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS1800',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-0F8R-0003',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS1600',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-0F8R-0004',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS2000(1500)',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-0F8R-0005',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS2000(800)',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-0F8R-0006',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS2000(600)',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-45KU-0001',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS2000',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-45KU-0002',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS1800',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-45KU-0003',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS1600',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-45KU-0004',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS2000(1500)',
        activePower: 1.5,
        apparentPower: 1.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-45KU-0005',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS2000(800)',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-EPYL-45KU-0006',
        manufacturerName: 'TSUNESS Co., Ltd',
        moduleType: 'TSOL-MS2000(600)',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-78FN-0DP0-0001',
        manufacturerName: 'Solarwatt GmbH',
        moduleType: 'Inverter vision one 1.0 (3.0 kW)',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-78FN-0DP0-0002',
        manufacturerName: 'Solarwatt GmbH',
        moduleType: 'Inverter vision one 1.0 (3.7 kW)',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-78FN-0DP0-0003',
        manufacturerName: 'Solarwatt GmbH',
        moduleType: 'Inverter vision one 1.0 (4.6 kW)',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-78FN-0DP0-0004',
        manufacturerName: 'Solarwatt GmbH',
        moduleType: 'Inverter vision one 1.0 (5.0 kW)',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-78FN-0DP0-0005',
        manufacturerName: 'Solarwatt GmbH',
        moduleType: 'Inverter vision one 1.0 (5.0 kW, NL)',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-78FN-0DP0-0006',
        manufacturerName: 'Solarwatt GmbH',
        moduleType: 'Inverter vision one 1.0 (6.0 kW)',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-78FN-0DP0-0007',
        manufacturerName: 'Solarwatt GmbH',
        moduleType: 'Inverter vision one 1.0 (6.0 kW, FR)',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0001',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-1000-2T',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0002',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-900-2T',
        activePower: 0.9,
        apparentPower: 0.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0003',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-800-2T',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0004',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-700-2T',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0005',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-600-2T',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0006',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-1000-2WB',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0007',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-900-2WB',
        activePower: 0.9,
        apparentPower: 0.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0008',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-800-2WB',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0009',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-700-2WB',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0010',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-600-2WB',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0011',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-1000W-2T',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0012',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-900W-2T',
        activePower: 0.9,
        apparentPower: 0.9,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0013',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-800W-2T',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0014',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-700W-2T',
        activePower: 0.7,
        apparentPower: 0.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-QY56-0015',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-600W-2T',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-SFEQ-0001',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-2000-4T',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-SFEQ-0002',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-1800-4T',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-SFEQ-0003',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-1600-4T',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-SFEQ-0004',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-2000-4WB',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-SFEQ-0005',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-1800-4WB',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-SFEQ-0006',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-1600-4WB',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0001',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-4K-M',
        activePower: 4.0,
        apparentPower: 4.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0002',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-5K-M',
        activePower: 5.0,
        apparentPower: 5.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0003',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-6K-M',
        activePower: 6.0,
        apparentPower: 6.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0004',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-8K-M',
        activePower: 8.0,
        apparentPower: 8.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0005',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-10K-M',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0006',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-12K-M',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0007',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-10K-M4',
        activePower: 10.0,
        apparentPower: 11.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0008',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-12K-M4',
        activePower: 12.0,
        apparentPower: 13.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0009',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-15K-M4',
        activePower: 15.0,
        apparentPower: 16.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KDZ0-FGWN-0010',
        manufacturerName: 'Jiangsu Hanchu Energy Technology Co., Ltd',
        moduleType: 'HESS-HY-T-20K-M4',
        activePower: 20.0,
        apparentPower: 22.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 4600 UP',
        activePower: 4600.0,
        apparentPower: 4600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 4400 UP',
        activePower: 4400.0,
        apparentPower: 4400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 4200 UP',
        activePower: 4200.0,
        apparentPower: 4200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 4000 UP',
        activePower: 4000.0,
        apparentPower: 4000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0005',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 3060 UP',
        activePower: 3067.0,
        apparentPower: 3067.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0006',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2930 UP',
        activePower: 2933.0,
        apparentPower: 2933.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0007',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2800 UP',
        activePower: 2800.0,
        apparentPower: 2800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0008',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2660 UP',
        activePower: 2667.0,
        apparentPower: 2667.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0009',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2475-10',
        activePower: 2475.0,
        apparentPower: 2475.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0010',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2200-10',
        activePower: 2200.0,
        apparentPower: 2200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0011',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3950 UP-XT',
        activePower: 4600.0,
        apparentPower: 4600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0012',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3800 UP-XT',
        activePower: 4400.0,
        apparentPower: 4400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0013',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3600 UP-XT',
        activePower: 4200.0,
        apparentPower: 4200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0014',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3450 UP-XT',
        activePower: 4000.0,
        apparentPower: 4000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0015',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3950 UP',
        activePower: 3960.0,
        apparentPower: 3960.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0016',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3800 UP',
        activePower: 3800.0,
        apparentPower: 3800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0017',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3600 UP',
        activePower: 3620.0,
        apparentPower: 3620.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0018',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3450 UP',
        activePower: 3450.0,
        apparentPower: 3450.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0019',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2630 UP-XT',
        activePower: 3067.0,
        apparentPower: 3067.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0020',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2530 UP-XT',
        activePower: 2933.0,
        apparentPower: 2933.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0021',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2400 UP-XT',
        activePower: 2800.0,
        apparentPower: 2800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0022',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2300 UP-XT',
        activePower: 2667.0,
        apparentPower: 2667.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0023',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2900-10',
        activePower: 2940.0,
        apparentPower: 2940.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0024',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2475-10',
        activePower: 2475.0,
        apparentPower: 2475.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0025',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2200-10',
        activePower: 2200.0,
        apparentPower: 2200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-7ZWF-LY3O-0026',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 1900-10',
        activePower: 1900.0,
        apparentPower: 1900.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-BFDK-GIXQ-0001',
        manufacturerName: 'TRUMPF Hüttinger GmbH + Co. KG',
        moduleType: 'TruConvert AC3025',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-BFDK-H611-0001',
        manufacturerName: 'TRUMPF Hüttinger GmbH + Co. KG',
        moduleType: 'TruConvert AC3025',
        activePower: 25.0,
        apparentPower: 25.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-C0SK-GVUK-0001',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'A17C1',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-GVUK-0002',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'A17C3',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-DCH0-0002',
        manufacturerName: 'Anker Innovations Limited',
        moduleType:
            'A17C53Z1-20, A17C53Z1-20-1, A17C53Z1-20-2, A17C53Z1-20-3, A17C53Z1-20-4, A17C53Z1-20-5, ',
        activePower: 1.2,
        apparentPower: 1.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-DCH0-0001',
        manufacturerName: 'Anker Innovations Limited',
        moduleType:
            'A17C53Z1, A17C53Z1-1, A17C53Z1-2, A17C53Z1-3, A17C53Z1-4, A17C53Z1-5',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0011',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3950 UP-XT',
        activePower: 4600.0,
        apparentPower: 4600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0012',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3800 UP-XT',
        activePower: 4400.0,
        apparentPower: 4400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0013',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3600 UP-XT',
        activePower: 4200.0,
        apparentPower: 4200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0014',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3450 UP-XT',
        activePower: 4000.0,
        apparentPower: 4000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0019',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2630 UP-XT',
        activePower: 3067.0,
        apparentPower: 3067.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0020',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2530 UP-XT',
        activePower: 2933.0,
        apparentPower: 2933.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0021',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2400 UP-XT',
        activePower: 2800.0,
        apparentPower: 2800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0022',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2300 UP-XT',
        activePower: 2667.0,
        apparentPower: 2667.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0015',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3950 UP',
        activePower: 3960.0,
        apparentPower: 3960.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0016',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3800 UP',
        activePower: 3800.0,
        apparentPower: 3800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0017',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3600 UP',
        activePower: 3620.0,
        apparentPower: 3620.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0018',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 3450 UP',
        activePower: 3450.0,
        apparentPower: 3450.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0023',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2900-10',
        activePower: 2940.0,
        apparentPower: 2940.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0024',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2475-10',
        activePower: 2475.0,
        apparentPower: 2475.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0025',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 2200-10',
        activePower: 2200.0,
        apparentPower: 2200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0001',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-300-1T',
        activePower: 0.3,
        apparentPower: 0.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0002',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-350-1T',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0003',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-400-1T',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0004',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-450-1T',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0005',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-500-1T',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0006',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-300-1WB',
        activePower: 0.3,
        apparentPower: 0.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0007',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-350-1WB',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0008',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-400-1WB',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0009',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-450-1WB',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0010',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-500-1WB',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0011',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-300BM',
        activePower: 0.3,
        apparentPower: 0.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0012',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-350BM',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0013',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-400BM',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0014',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-450BM',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0015',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-500BM',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0016',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-300W-1T',
        activePower: 0.3,
        apparentPower: 0.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0017',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-350W-1T',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0018',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-400W-1T',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0019',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-450W-1T',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EO79-0020',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HMS-500W-1T',
        activePower: 0.5,
        apparentPower: 0.5,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0026',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SCS 1900-10',
        activePower: 1900.0,
        apparentPower: 1900.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0001',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 4600 UP',
        activePower: 4600.0,
        apparentPower: 4600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0002',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 4400 UP',
        activePower: 4400.0,
        apparentPower: 4400.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0003',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 4200 UP',
        activePower: 4200.0,
        apparentPower: 4200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0004',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 4000 UP',
        activePower: 4000.0,
        apparentPower: 4000.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0005',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 3060 UP',
        activePower: 3067.0,
        apparentPower: 3067.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0006',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2930 UP',
        activePower: 2933.0,
        apparentPower: 2933.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0007',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2800 UP',
        activePower: 2800.0,
        apparentPower: 2800.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0008',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2660 UP',
        activePower: 2667.0,
        apparentPower: 2667.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0009',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2475-10',
        activePower: 2475.0,
        apparentPower: 2475.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-HDBB-G8E5-0010',
        manufacturerName: 'SMA Solar Technology AG',
        moduleType: 'SC 2200-10',
        activePower: 2200.0,
        apparentPower: 2200.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-M1H3-X2ZN-0001',
        manufacturerName: 'MUST ENERGY (GUANGDONG) TECHNOLOGY CO.,LTD',
        moduleType: 'PH11-3648PRO \nMH12-3648PLUS',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-M1H3-X2ZN-0002',
        manufacturerName: 'MUST ENERGY (GUANGDONG) TECHNOLOGY CO.,LTD',
        moduleType: 'PH11-4048PRO \nMH12-4048PLUS',
        activePower: 4.0,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-M1H3-X2ZN-0003',
        manufacturerName: 'MUST ENERGY (GUANGDONG) TECHNOLOGY CO.,LTD',
        moduleType: 'PH11-4648PRO \nMH12-4648PLUS',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-M1H3-5YCA-0001',
        manufacturerName: 'MUST ENERGY (GUANGDONG) TECHNOLOGY CO.,LTD',
        moduleType: 'PM-800',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-M1H3-5YCA-0002',
        manufacturerName: 'MUST ENERGY (GUANGDONG) TECHNOLOGY CO.,LTD',
        moduleType: 'PM-1000',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-CQHG-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'M1-1200-E',
        activePower: 1.2,
        apparentPower: 1.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-CQHG-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'M1-1000-E',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-CQHG-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'M1-800-E',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-CQHG-0004',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'M1-600-E',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-AN4I-0001',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Argeno 125',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-AN4I-0002',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Argeno 125 EXC.',
        activePower: 125.0,
        apparentPower: 124.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-AN4I-0003',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Argeno 125 AFCI',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-AN4I-0004',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Argeno 125 AFCI EXC.',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-AN4I-0005',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Argeno 125 FR',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-AN4I-0006',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Argeno 125 FR EXC.',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-AN4I-0007',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Argeno 125 UA',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-N29R-AN4I-0008',
        manufacturerName: 'FRONIUS International GmbH',
        moduleType: 'Argeno 125 UA EXC.',
        activePower: 125.0,
        apparentPower: 125.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-0WQ1-0001',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHC-4KT-U2',
        activePower: 4.1,
        apparentPower: 4.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-0WQ1-0002',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHC-5KT-U2',
        activePower: 5.1,
        apparentPower: 5.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-0WQ1-0003',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHC-6KT-U2',
        activePower: 6.1,
        apparentPower: 6.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-0WQ1-0004',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHC-8KT-U2',
        activePower: 8.0,
        apparentPower: 8.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-0WQ1-0005',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHC-10KT-U2',
        activePower: 10.1,
        apparentPower: 10.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-0WQ1-0006',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHC-12KT-U2',
        activePower: 12.3,
        apparentPower: 12.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-0WQ1-0007',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHC-15KT-U2',
        activePower: 15.1,
        apparentPower: 15.1,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-0WQ1-0008',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHC-20KT-U2',
        activePower: 20.7,
        apparentPower: 20.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0001',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-5.0-E',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0002',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-6.0-E',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0003',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-8.0-E',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0004',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-10.0-E',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0005',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'H3-12.0-E',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0006',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-5.0-E',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0007',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-6.0-E',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0008',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-8.0-E',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0009',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-10.0-E',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AEW3-FFPH-0010',
        manufacturerName: 'FOXESS CO., LTD.',
        moduleType: 'AC3-12.0-E',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-IC9T-0001',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-1600',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-IC9T-0002',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-1600-W',
        activePower: 1.6,
        apparentPower: 1.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-IC9T-0003',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-1800',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-IC9T-0004',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-1800-W',
        activePower: 1.8,
        apparentPower: 1.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-IC9T-0005',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-2000',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-IC9T-0006',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-2000-W',
        activePower: 2.0,
        apparentPower: 2.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-IC9T-0007',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-2200',
        activePower: 2.2,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-ZQ5I-IC9T-0008',
        manufacturerName: 'Xiamen E-star Energy Co., Ltd.',
        moduleType: 'ES-2200-W',
        activePower: 2.2,
        apparentPower: 2.2,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KYYX-2EUL-0001',
        manufacturerName: 'Pixii Germany GmbH',
        moduleType: 'PixiiBox 48/3300',
        activePower: 3.3,
        apparentPower: 3.3,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-FAHM-D8TT-0001',
        manufacturerName: 'Pramac Storage Systems GmbH',
        moduleType: '422P050',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-FAHM-D8TT-0002',
        manufacturerName: 'Pramac Storage Systems GmbH',
        moduleType: '422P090',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-FAHM-D8TT-0003',
        manufacturerName: 'Pramac Storage Systems GmbH',
        moduleType: '423P090',
        activePower: 90.0,
        apparentPower: 90.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EUJA-0001',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HYS-3.0LV-EUG1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EUJA-0002',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HYS-3.6LV-EUG1',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EUJA-0003',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HYS-4.6LV-EUG1',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EUJA-0004',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HYS-5.0LV-EUG1',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EUJA-0005',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HYS-6.0LV-EUG1',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EUJA-0006',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HAS-3.0LV-EUG1',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EUJA-0007',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HAS-3.6LV-EUG1',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EUJA-0008',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HAS-4.6LV-EUG1',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-XLWY-EUJA-0009',
        manufacturerName: 'Hoymiles Power Electronics Inc.',
        moduleType: 'HAS-5.0LV-EUG1',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-M1H3-5YCA-0003',
        manufacturerName: 'MUST ENERGY (GUANGDONG) TECHNOLOGY CO.,LTD',
        moduleType: 'PM-800',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-M1H3-5YCA-0004',
        manufacturerName: 'MUST ENERGY (GUANGDONG) TECHNOLOGY CO.,LTD',
        moduleType: 'PM-1000',
        activePower: 1.0,
        apparentPower: 1.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0001',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0050-ES-1-400-1',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0002',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0100-ES-1-400-1',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0003',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATY0100-ES-1-400-1',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0004',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0280-ES-1-400-1',
        activePower: 280.0,
        apparentPower: 280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0005',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATY0280-ES-1-400-1',
        activePower: 280.0,
        apparentPower: 280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0006',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATI0600-ES-1-270-1',
        activePower: 600.0,
        apparentPower: 600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0007',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATI0720-ES-1-300-1',
        activePower: 720.0,
        apparentPower: 720.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0008',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATI0900-ES-1-380-1',
        activePower: 900.0,
        apparentPower: 900.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0009',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0100-ES-1-400-1 (Outdoor)',
        activePower: 120.0,
        apparentPower: 120.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0010',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATY0100-ES-1-400-1 (Outdoor)',
        activePower: 120.0,
        apparentPower: 120.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0011',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0280-ES-1-400-1 (Outdoor)',
        activePower: 280.0,
        apparentPower: 280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-QKMO-0012',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATY0280-ES-1-400-1 (Outdoor)',
        activePower: 280.0,
        apparentPower: 280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0001',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0050-ES-1-400-1',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0002',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0100-ES-1-400-1',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0003',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATY0100-ES-1-400-1',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0004',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0280-ES-1-400-1',
        activePower: 280.0,
        apparentPower: 280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0005',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATY0280-ES-1-400-1',
        activePower: 280.0,
        apparentPower: 280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0006',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATI0600-ES-1-270-1',
        activePower: 600.0,
        apparentPower: 600.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0007',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATI0720-ES-1-300-1',
        activePower: 720.0,
        apparentPower: 720.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0008',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATI0900-ES-1-380-1',
        activePower: 900.0,
        apparentPower: 900.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0009',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0100-ES-1-400-1 (Outdoor)',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0010',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATY0100-ES-1-400-1 (Outdoor)',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0011',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATD0280-ES-1-400-1 (Outdoor)',
        activePower: 280.0,
        apparentPower: 280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-AFK6-2U1R-0012',
        manufacturerName: 'WSTECH GmbH',
        moduleType: 'BATY0280-ES-1-400-1 (Outdoor)',
        activePower: 280.0,
        apparentPower: 280.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-HS75-0001',
        manufacturerName: 'Shenzhen Donnergy Technology Co.,Ltd',
        moduleType: 'GT800TL',
        activePower: 0.8,
        apparentPower: 0.8,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-HS75-0002',
        manufacturerName: 'Shenzhen Donnergy Technology Co.,Ltd',
        moduleType: 'GT600TL',
        activePower: 0.6,
        apparentPower: 0.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-PWRY-HS75-0003',
        manufacturerName: 'Shenzhen Donnergy Technology Co.,Ltd',
        moduleType: 'GT400TL',
        activePower: 0.4,
        apparentPower: 0.4,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-KWZS-O52W-0001',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-50KTL-M0',
        activePower: 50.0,
        apparentPower: 50.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-KWZS-O52W-0002',
        manufacturerName: 'Huawei Technologies Co., Ltd.',
        moduleType: 'SUN2000-60KTL-M0',
        activePower: 60.0,
        apparentPower: 60.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-MVNQ-CW1D-0001',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHome-3K0L',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-CW1D-0002',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHome-3K6L',
        activePower: 4.1,
        apparentPower: 4.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-CW1D-0003',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHome-4K0L',
        activePower: 3.7,
        apparentPower: 3.7,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-MVNQ-CW1D-0004',
        manufacturerName: 'UCanPower GmbH',
        moduleType: 'UHome-4K6L',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-X3NN-MHA6-0001',
        manufacturerName: 'Sungrow Power Supply Co., Ltd.',
        moduleType: 'SG110CX',
        activePower: 100.0,
        apparentPower: 100.0,
        connectionRulesTypes: [ConnectionRulesType.rules4110],
    },
    {
        zerezId: 'ZE-C0SK-RL8S-0001',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-H3.68K-S',
        activePower: 3.6,
        apparentPower: 3.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-RL8S-0002',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-H4.6K-S',
        activePower: 4.6,
        apparentPower: 4.6,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-RL8S-0003',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-H5K-S',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-RL8S-0004',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-H6K-S',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-1NCB-0001',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-H5K-T',
        activePower: 5.0,
        apparentPower: 5.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-1NCB-0002',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-H8K-T',
        activePower: 8.0,
        apparentPower: 8.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-1NCB-0003',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-H10K-T',
        activePower: 10.0,
        apparentPower: 10.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-1NCB-0004',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-H12K-T',
        activePower: 12.0,
        apparentPower: 12.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-YMJY-0001',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-P6K-B05-S',
        activePower: 3.0,
        apparentPower: 3.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-YMJY-0002',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-P6K-B10-S',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-YMJY-0003',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-P6K-B15-S',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-YMJY-0004',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-P6K-B20-S',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-YMJY-0005',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-P6K-B25-S',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
    {
        zerezId: 'ZE-C0SK-YMJY-0006',
        manufacturerName: 'Anker Innovations Limited',
        moduleType: 'X1-P6K-B30-S',
        activePower: 6.0,
        apparentPower: 6.0,
        connectionRulesTypes: [ConnectionRulesType.rules4105],
    },
];
